import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LabelAndCode: { input: any; output: any; }
  LatLng: { input: any; output: any; }
  MongoSortQuery: { input: any; output: any; }
  ObjectId: { input: string; output: string; }
};

export type AccountData = {
  __typename?: 'AccountData';
  account?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
  bankId?: Maybe<Scalars['ObjectId']['output']>;
};

export type Address = {
  __typename?: 'Address';
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export enum BasicCoverageTypes {
  Custeio = 'custeio',
  Parametrico = 'parametrico',
  Produtividade = 'produtividade',
  RiscoNomeado = 'risco_nomeado'
}

export type CategoryDashboardCounters = {
  __typename?: 'CategoryDashboardCounters';
  count: Scalars['Int']['output'];
  statuses?: Maybe<Array<StatusDashboardCounters>>;
  value: Scalars['String']['output'];
};

export type Claim = {
  __typename?: 'Claim';
  _id: Scalars['ObjectId']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contestationLetterFile?: Maybe<File>;
  contestationLetterFileUploadDate?: Maybe<Scalars['Date']['output']>;
  contestationProtocolNumber?: Maybe<Scalars['Float']['output']>;
  coverages: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  dateOfReanalysis?: Maybe<Scalars['Date']['output']>;
  documentId: Scalars['ObjectId']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  estimatedIndemnity?: Maybe<Scalars['Float']['output']>;
  events: Array<ClaimEvent>;
  externalId: Scalars['String']['output'];
  indemnityAmount?: Maybe<Scalars['Float']['output']>;
  indemnityPaymentDate?: Maybe<Scalars['Date']['output']>;
  lossEstimate: LossEstimate;
  name: Scalars['String']['output'];
  noticeDate: Scalars['Date']['output'];
  plots?: Maybe<Array<Scalars['String']['output']>>;
  protocolNumber?: Maybe<Scalars['String']['output']>;
  reportFile?: Maybe<File>;
  reportFileUploadDate?: Maybe<Scalars['Date']['output']>;
  startDate: Scalars['Date']['output'];
  status: ClaimStatus;
};

export enum ClaimEvent {
  ColdWinds = 'coldWinds',
  Drought = 'drought',
  Fire = 'fire',
  Frost = 'frost',
  Hail = 'hail',
  Inundation = 'inundation',
  Lightning = 'lightning',
  Rain = 'rain',
  TemperatureVariation = 'temperatureVariation',
  Waterspout = 'waterspout',
  Wind = 'wind'
}

export enum ClaimStatus {
  Approved = 'approved',
  Contested = 'contested',
  Open = 'open',
  Paid = 'paid',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type Contact = {
  __typename?: 'Contact';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  addressProofFile?: Maybe<File>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  civilState?: Maybe<Scalars['String']['output']>;
  cpfCnpj?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  documentFile?: Maybe<File>;
  email?: Maybe<Scalars['String']['output']>;
  emissionInstitution?: Maybe<Scalars['String']['output']>;
  emissionInstitutionId?: Maybe<Scalars['ObjectId']['output']>;
  expeditionDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentRelation?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  professionId?: Maybe<Scalars['ObjectId']['output']>;
  rg?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ContactTags {
  Beneficiary = 'beneficiary',
  Consultant = 'consultant',
  Farmer = 'farmer',
  Inspector = 'inspector',
  PaymentResponsible = 'paymentResponsible'
}

export type ConversationUpdated = {
  __typename?: 'ConversationUpdated';
  contactId: Scalars['String']['output'];
  newMsg: Scalars['Boolean']['output'];
};

export type CoverageEvent = {
  __typename?: 'CoverageEvent';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name: Scalars['String']['output'];
};

export enum CoverageTags {
  Additional = 'additional',
  Basic = 'basic',
  Fire = 'fire',
  Frost = 'frost',
  Hail = 'hail',
  PhytosanitaryTreatment = 'phytosanitary_treatment',
  PlantLife = 'plant_life',
  ProductionLoss = 'production_loss',
  Wind = 'wind'
}

export type Coverages = {
  __typename?: 'Coverages';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  insuranceTypes?: Maybe<Array<Maybe<InsuranceType>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Crop = {
  __typename?: 'Crop';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  compositionType?: Maybe<Scalars['LabelAndCode']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropYear?: Maybe<Scalars['String']['output']>;
  culture?: Maybe<Culture>;
  cultureDetail?: Maybe<CultureDetail>;
  cultureDetailId?: Maybe<Scalars['ObjectId']['output']>;
  cultureId?: Maybe<Scalars['ObjectId']['output']>;
  cultureName?: Maybe<Scalars['String']['output']>;
  harvestEndDate?: Maybe<Scalars['Date']['output']>;
  harvestStartDate?: Maybe<Scalars['Date']['output']>;
  kmlFile?: Maybe<File>;
  manualCulture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plots?: Maybe<Array<Plot>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CropInsuranceQuestions = {
  __typename?: 'CropInsuranceQuestions';
  federalSubvention?: Maybe<Scalars['Boolean']['output']>;
  firstCrop?: Maybe<Scalars['Boolean']['output']>;
  isPlanted?: Maybe<Scalars['Boolean']['output']>;
  nightIrrigation?: Maybe<Scalars['Boolean']['output']>;
  organicCulture?: Maybe<Scalars['Boolean']['output']>;
  otherInsurances?: Maybe<Scalars['Boolean']['output']>;
  pronampBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  recentIncident?: Maybe<Scalars['Boolean']['output']>;
  stateSubvention?: Maybe<Scalars['Boolean']['output']>;
  withSubvention?: Maybe<Scalars['Boolean']['output']>;
  zarcPolicy?: Maybe<Scalars['Boolean']['output']>;
};

export type Culture = {
  __typename?: 'Culture';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  codMapfre?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CultureDetail = {
  __typename?: 'CultureDetail';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  codMapfre?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  culture?: Maybe<Culture>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DashboardTotalValue = {
  __typename?: 'DashboardTotalValue';
  category: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum DashboardTotalValueDateRange {
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type DocumentEquipment = {
  __typename?: 'DocumentEquipment';
  equipment?: Maybe<Equipment>;
  equipmentId: Scalars['ObjectId']['output'];
  hasTheftCoverage?: Maybe<Scalars['Boolean']['output']>;
  isFinanced?: Maybe<Scalars['Boolean']['output']>;
  isLeased?: Maybe<Scalars['Boolean']['output']>;
  isNearWater?: Maybe<Scalars['Boolean']['output']>;
  isNewEquipment?: Maybe<Scalars['Boolean']['output']>;
  isRenewal?: Maybe<Scalars['Boolean']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  previousProvider?: Maybe<PropostaProviders>;
  serialNumberMatch?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentReject = {
  __typename?: 'DocumentReject';
  other?: Maybe<Scalars['String']['output']>;
  rejectReason: DocumentRejectReason;
};

export enum DocumentRejectReason {
  ContactLost = 'contactLost',
  NotAvailable = 'notAvailable',
  Other = 'other',
  OutOfCoveragePeriod = 'outOfCoveragePeriod',
  PriceTooHigh = 'priceTooHigh'
}

export enum DocumentStages {
  Claim = 'claim',
  Policy = 'policy',
  Proposal = 'proposal',
  Quotation = 'quotation',
  Simulation = 'simulation'
}

export enum DocumentStatus {
  Cancelled = 'cancelled',
  Done = 'done',
  Effective = 'effective',
  Incomplete = 'incomplete',
  NonEffective = 'nonEffective',
  Pending = 'pending',
  Rejected = 'rejected',
  Sent = 'sent',
  UnderAnalysis = 'underAnalysis'
}

export type DocumentsFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cultureId?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['JSON']['input']>;
  insuranceTypeGroup?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  responsableId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  brand?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ObjectId']['output'];
  manualBrand?: Maybe<Scalars['String']['output']>;
  manualType?: Maybe<Scalars['String']['output']>;
  manufactureYear: Scalars['String']['output'];
  marketValue?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['ObjectId']['output'];
  property?: Maybe<Property>;
  propertyId: Scalars['ObjectId']['output'];
  type?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['ObjectId']['output'];
};

export type EquipmentBrand = {
  __typename?: 'EquipmentBrand';
  _id: Scalars['ObjectId']['output'];
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type EquipmentType = {
  __typename?: 'EquipmentType';
  _id: Scalars['ObjectId']['output'];
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type FieldUpdateResponse = {
  __typename?: 'FieldUpdateResponse';
  error?: Maybe<Scalars['String']['output']>;
  fieldPath: Scalars['String']['output'];
  invisible?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FormDataOptions>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type File = {
  __typename?: 'File';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  fileKey?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

export type FormDataOptions = {
  __typename?: 'FormDataOptions';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type FormRequestResponse = {
  __typename?: 'FormRequestResponse';
  formId: Scalars['String']['output'];
  formResponseId: Scalars['String']['output'];
};

export type FormResponse = {
  __typename?: 'FormResponse';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  formData?: Maybe<Scalars['JSON']['output']>;
  formState?: Maybe<Scalars['JSON']['output']>;
};

export enum FormResponseStatus {
  Editing = 'editing',
  Submited = 'submited'
}

export type Inspection = {
  __typename?: 'Inspection';
  _id: Scalars['ObjectId']['output'];
  claimIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  claims?: Maybe<Array<Maybe<Claim>>>;
  date: Scalars['Date']['output'];
  documentId: Scalars['ObjectId']['output'];
  inspector?: Maybe<Contact>;
  inspectorId: Scalars['ObjectId']['output'];
  regulatoryAgency: Scalars['String']['output'];
  reportFile?: Maybe<File>;
  status: InspectionStatus;
  type: InspectionType;
};

export enum InspectionStatus {
  Done = 'done',
  Pending = 'pending'
}

export enum InspectionType {
  Final = 'final',
  Preliminary = 'preliminary'
}

export type InsuranceDocument = {
  __typename?: 'InsuranceDocument';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  allowedVisitPeople?: Maybe<Array<Contact>>;
  allowedVisitPeopleIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  archivedProposals?: Maybe<Array<Result>>;
  beneficiary?: Maybe<Contact>;
  beneficiaryId?: Maybe<Scalars['ObjectId']['output']>;
  claimResponsible?: Maybe<User>;
  claimResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  claims?: Maybe<Array<Claim>>;
  commercialResponsible?: Maybe<User>;
  commercialResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  costNFFiles?: Maybe<Array<File>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  crop?: Maybe<Crop>;
  cropId?: Maybe<Scalars['ObjectId']['output']>;
  equipments?: Maybe<Array<DocumentEquipment>>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  failedSimulationResults?: Maybe<Array<Maybe<Result>>>;
  farmer?: Maybe<Contact>;
  farmerId: Scalars['ObjectId']['output'];
  hasComplementaryData?: Maybe<Scalars['Boolean']['output']>;
  inspections?: Maybe<Array<Inspection>>;
  insuranceTypeGroup?: Maybe<InsuranceTypeGroupEnum>;
  justificationMessage?: Maybe<Scalars['String']['output']>;
  kmlFile?: Maybe<File>;
  operationalResponsible?: Maybe<User>;
  operationalResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  originator?: Maybe<User>;
  originatorId?: Maybe<Scalars['ObjectId']['output']>;
  paymentData?: Maybe<PaymentData>;
  payments?: Maybe<Array<Payment>>;
  policy?: Maybe<Policy>;
  policyId?: Maybe<Scalars['ObjectId']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ObjectId']['output']>;
  proposalFile?: Maybe<File>;
  proposalResult?: Maybe<Result>;
  proposalResultId?: Maybe<Scalars['ObjectId']['output']>;
  provider?: Maybe<PropostaProviders>;
  questions?: Maybe<CropInsuranceQuestions>;
  quotationDate?: Maybe<Scalars['Date']['output']>;
  recommendedSimulationResultId?: Maybe<Scalars['ObjectId']['output']>;
  rejectReason?: Maybe<DocumentReject>;
  selectedResultIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  selectedSimulationResults?: Maybe<Array<Maybe<Result>>>;
  simulationResults?: Maybe<Array<Maybe<Result>>>;
  specialOperation?: Maybe<SpecialOperation>;
  specialOperationId?: Maybe<Scalars['ObjectId']['output']>;
  stage?: Maybe<DocumentStages>;
  status?: Maybe<DocumentStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validSimulationResults?: Maybe<Array<Maybe<Result>>>;
  visitPerson?: Maybe<Contact>;
  visitPersonId?: Maybe<Scalars['ObjectId']['output']>;
};

export type InsuranceGroup = {
  __typename?: 'InsuranceGroup';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<InsuranceType>>>;
};

export type InsuranceType = {
  __typename?: 'InsuranceType';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  group?: Maybe<InsuranceGroup>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum InsuranceTypeGroupEnum {
  Agricultural = 'agricultural',
  Machinery = 'machinery'
}

export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  _id: Scalars['ObjectId']['output'];
  culture?: Maybe<Culture>;
  cultureId: Scalars['ObjectId']['output'];
  swiss?: Maybe<SwissSettings>;
};

export type Lead = {
  __typename?: 'Lead';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  area?: Maybe<Scalars['Float']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  commercialResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cultureIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  cultures?: Maybe<Array<Culture>>;
  email?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  meetingIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  meetings?: Maybe<Array<Meeting>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<RatingScale>;
  status?: Maybe<LeadStatus>;
  technicalResponsibleId?: Maybe<Scalars['ObjectId']['output']>;
  type?: Maybe<LeadTypes>;
};

export type LeadFiltersInput = {
  rating?: InputMaybe<RatingScale>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  type?: InputMaybe<LeadTypes>;
};

export enum LeadStatus {
  Deal = 'deal',
  New = 'new',
  Pitch = 'pitch',
  Refused = 'refused',
  Scrutiny = 'scrutiny'
}

export enum LeadTypes {
  Customer = 'customer',
  Partner = 'partner'
}

export enum LossEstimate {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type Meeting = {
  __typename?: 'Meeting';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  attachment?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  date: Scalars['Date']['output'];
  responsible?: Maybe<User>;
  responsibleId: Scalars['ObjectId']['output'];
  status: MeetingStatus;
  topic: MeetingTopics;
};

export enum MeetingStatus {
  Done = 'done',
  Scheduled = 'scheduled'
}

export enum MeetingTopics {
  Followup = 'followup',
  Intro = 'intro',
  Quotation = 'quotation'
}

export type MsgSeenUpdated = {
  __typename?: 'MsgSeenUpdated';
  userId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addClaimResponsibleToDocument: Scalars['Boolean']['output'];
  addCommentToLead: Scalars['Boolean']['output'];
  addCommentToUser: Scalars['Boolean']['output'];
  addCommercialResponsibleToDocument: Scalars['Boolean']['output'];
  addCommercialResponsibleToLead: Scalars['Boolean']['output'];
  addCourseToUser: Scalars['Boolean']['output'];
  addCultureToUser: Scalars['Boolean']['output'];
  addOperationalResponsibleToDocument: Scalars['Boolean']['output'];
  addOriginatorToDocument: Scalars['Boolean']['output'];
  addRatingToUser: Scalars['Boolean']['output'];
  addResponsibleToUser: Scalars['Boolean']['output'];
  addTechnicalResponsibleToLead: Scalars['Boolean']['output'];
  approveSimulationResult: Scalars['Boolean']['output'];
  archiveDocument: Scalars['Boolean']['output'];
  archiveProposal: Scalars['Boolean']['output'];
  changeLeadStatus: Scalars['Boolean']['output'];
  createFormResponse: FormResponse;
  createNote: Scalars['JSON']['output'];
  deletePayment: Scalars['Boolean']['output'];
  deleteSimulationResult: Scalars['Boolean']['output'];
  finishSimulation: Scalars['Boolean']['output'];
  getOrCreateContactByPhone: Contact;
  invalidateCacheByGroupKey: Scalars['Boolean']['output'];
  rateLead: Scalars['Boolean']['output'];
  recedeDocumentStageToSimulation: Scalars['Boolean']['output'];
  recommendSimulationResult: Scalars['Boolean']['output'];
  redoQuotations: Scalars['Boolean']['output'];
  removeRecommendedSimulationResult: Scalars['Boolean']['output'];
  retrySimulationResult: Scalars['Boolean']['output'];
  selectResults: Scalars['Boolean']['output'];
  sendPolicy: Scalars['Boolean']['output'];
  sendProposal: Scalars['Boolean']['output'];
  sendQuotation: Scalars['Boolean']['output'];
  sendTransactionalEvent: Scalars['JSON']['output'];
  sendTwilioWAMessage: Scalars['Boolean']['output'];
  setIndemnityPaid?: Maybe<Scalars['Boolean']['output']>;
  setPaymentDone: Scalars['Boolean']['output'];
  setQuotationComment: Scalars['Boolean']['output'];
  submitFormResponse: Scalars['JSON']['output'];
  upsertFormField: Array<Maybe<Scalars['JSON']['output']>>;
};


export type MutationAddClaimResponsibleToDocumentArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationAddCommentToLeadArgs = {
  comment: Scalars['String']['input'];
  leadId: Scalars['String']['input'];
};


export type MutationAddCommentToUserArgs = {
  comment: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddCommercialResponsibleToDocumentArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationAddCommercialResponsibleToLeadArgs = {
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
};


export type MutationAddCourseToUserArgs = {
  finishedCourse: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddCultureToUserArgs = {
  cultureIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  userId: Scalars['String']['input'];
};


export type MutationAddOperationalResponsibleToDocumentArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationAddOriginatorToDocumentArgs = {
  contactId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
};


export type MutationAddRatingToUserArgs = {
  rating: RatingScale;
  userId: Scalars['String']['input'];
};


export type MutationAddResponsibleToUserArgs = {
  responsibleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddTechnicalResponsibleToLeadArgs = {
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
};


export type MutationApproveSimulationResultArgs = {
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
};


export type MutationArchiveDocumentArgs = {
  docId: Scalars['String']['input'];
};


export type MutationArchiveProposalArgs = {
  docId: Scalars['String']['input'];
};


export type MutationChangeLeadStatusArgs = {
  leadId: Scalars['String']['input'];
  status: LeadStatus;
};


export type MutationCreateFormResponseArgs = {
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
};


export type MutationCreateNoteArgs = {
  authorId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  serviceName: Services;
  text: Scalars['String']['input'];
};


export type MutationDeletePaymentArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationDeleteSimulationResultArgs = {
  resultId: Scalars['String']['input'];
};


export type MutationFinishSimulationArgs = {
  docId: Scalars['String']['input'];
};


export type MutationGetOrCreateContactByPhoneArgs = {
  mobilePhone: Scalars['String']['input'];
};


export type MutationInvalidateCacheByGroupKeyArgs = {
  groupKey: Scalars['String']['input'];
};


export type MutationRateLeadArgs = {
  leadId: Scalars['String']['input'];
  rating: RatingScale;
};


export type MutationRecedeDocumentStageToSimulationArgs = {
  docId: Scalars['String']['input'];
  docStatus: DocumentStatus;
};


export type MutationRecommendSimulationResultArgs = {
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
};


export type MutationRedoQuotationsArgs = {
  docId: Scalars['String']['input'];
};


export type MutationRemoveRecommendedSimulationResultArgs = {
  docId: Scalars['String']['input'];
};


export type MutationRetrySimulationResultArgs = {
  resultId: Scalars['String']['input'];
};


export type MutationSelectResultsArgs = {
  docId: Scalars['String']['input'];
  resultsIds: Array<Scalars['String']['input']>;
};


export type MutationSendPolicyArgs = {
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
};


export type MutationSendProposalArgs = {
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
};


export type MutationSendQuotationArgs = {
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
};


export type MutationSendTransactionalEventArgs = {
  docId: Scalars['String']['input'];
  event: TransactionalEvents;
};


export type MutationSendTwilioWaMessageArgs = {
  contactId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  files: Array<TwilioMediaInput>;
};


export type MutationSetIndemnityPaidArgs = {
  objectId: Scalars['String']['input'];
};


export type MutationSetPaymentDoneArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationSetQuotationCommentArgs = {
  docId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationSubmitFormResponseArgs = {
  formResponseId: Scalars['String']['input'];
};


export type MutationUpsertFormFieldArgs = {
  fieldPath: Scalars['String']['input'];
  formResponseId: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type Note = {
  __typename?: 'Note';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  authorId: User;
  createdAt?: Maybe<Scalars['Date']['output']>;
  documentId?: Maybe<Scalars['ObjectId']['output']>;
  serviceName?: Maybe<Services>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt: Scalars['Date']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  objectId: Scalars['ObjectId']['output'];
  originInfo: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  dateNotifications: Array<ObjectNotifications>;
  notificationDate: Scalars['Date']['output'];
};

export type ObjectNotifications = {
  __typename?: 'ObjectNotifications';
  groupNotifications: Array<Notification>;
  notificationGroup: Scalars['ObjectId']['output'];
};

export type PartnersFiltersInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoles>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type Payment = {
  __typename?: 'Payment';
  _id: Scalars['ObjectId']['output'];
  amount: Scalars['Float']['output'];
  billFile?: Maybe<File>;
  dateDue: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  provider: PropostaProviders;
  responsible?: Maybe<Contact>;
  responsibleId: Scalars['ObjectId']['output'];
  status: PaymentStatus;
  subventionType?: Maybe<SubventionType>;
};

export type PaymentData = {
  __typename?: 'PaymentData';
  accountData?: Maybe<AccountData>;
  installments?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<PaymentMethods>;
  responsible?: Maybe<Contact>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
};

export enum PaymentMethods {
  Boleto = 'boleto',
  Debit = 'debit'
}

export enum PaymentStatus {
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  Done = 'done',
  Pending = 'pending'
}

export type Plot = {
  __typename?: 'Plot';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropYear?: Maybe<Scalars['String']['output']>;
  cultureDetail?: Maybe<CultureDetail>;
  cultureDetailId?: Maybe<Scalars['ObjectId']['output']>;
  irrigated?: Maybe<Scalars['Boolean']['output']>;
  lineSpacing?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plantDate?: Maybe<Scalars['Date']['output']>;
  plantMethod?: Maybe<Scalars['String']['output']>;
  plantSpacing?: Maybe<Scalars['Float']['output']>;
  polygon?: Maybe<Array<Maybe<Scalars['LatLng']['output']>>>;
  property?: Maybe<Property>;
  seedType?: Maybe<Scalars['String']['output']>;
  soilType?: Maybe<Scalars['LabelAndCode']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Policy = {
  __typename?: 'Policy';
  _id: Scalars['ObjectId']['output'];
  billsFile?: Maybe<File>;
  cancellationReason?: Maybe<PolicyRejectReason>;
  documentId: Scalars['ObjectId']['output'];
  endDate: Scalars['Date']['output'];
  externalId: Scalars['String']['output'];
  farmerId: Scalars['ObjectId']['output'];
  insuranceTypeGroup: InsuranceTypeGroupEnum;
  policyFile: File;
  provider: PropostaProviders;
  startDate: Scalars['Date']['output'];
};

export enum PolicyRejectReason {
  Error = 'error',
  Quitclaim = 'quitclaim'
}

export type Property = {
  __typename?: 'Property';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  accessInstructions?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['ObjectId']['output']>;
  address?: Maybe<Address>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  entranceLocation?: Maybe<Scalars['LatLng']['output']>;
  kmlFile?: Maybe<Scalars['String']['output']>;
  manualActivity?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Contact>;
  plots?: Maybe<Array<Maybe<Plot>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PropertyActivity = {
  __typename?: 'PropertyActivity';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum PropostaProviders {
  Agrobrasil = 'agrobrasil',
  Allianz = 'allianz',
  Btg = 'btg',
  Essor = 'essor',
  Fairfax = 'fairfax',
  Kovr = 'kovr',
  Mapfre = 'mapfre',
  Porto = 'porto',
  Sancor = 'sancor',
  Sombrero = 'sombrero',
  Sompo = 'sompo',
  Swiss = 'swiss',
  Tokyo = 'tokyo'
}

export type Query = {
  __typename?: 'Query';
  countDocuments?: Maybe<Scalars['Int']['output']>;
  countLeads?: Maybe<Scalars['Int']['output']>;
  countUsers?: Maybe<Scalars['Int']['output']>;
  document?: Maybe<InsuranceDocument>;
  documents?: Maybe<Array<Maybe<InsuranceDocument>>>;
  getCancelPolicyOnDocumentFormResponse: FormRequestResponse;
  getComplementaryDataFormResponse: FormRequestResponse;
  getCreateClaimOnFormResponse: FormRequestResponse;
  getCreateInspectionOnFormResponse: FormRequestResponse;
  getCreateIntegrationSettingsFormResponse: FormRequestResponse;
  getCreateMeetingOnObjectFormResponse: FormRequestResponse;
  getCreateObjectFormResponse: Scalars['String']['output'];
  getCreatePaymentOnDocumentFormResponse: FormRequestResponse;
  getCreatePolicyOnDocumentFormResponse: FormRequestResponse;
  getCreateProposalOnDocumentFormResponse: FormRequestResponse;
  getCreateResultOnDocumentFormResponse: FormRequestResponse;
  getCreateSignedProposalOnFormResponse: FormRequestResponse;
  getDocumentRejectionFormResponse: FormRequestResponse;
  getDocumentsDashboardCounters?: Maybe<Array<CategoryDashboardCounters>>;
  getDocumentsDashboardTotalValues?: Maybe<Array<DashboardTotalValue>>;
  getEditBillsOnDocumentFormResponse: FormRequestResponse;
  getEditClaimOnFormResponse: FormRequestResponse;
  getEditConclusionLetterOnClaim: FormRequestResponse;
  getEditContestationLetterOnClaim: FormRequestResponse;
  getEditCropOnDocumentFormResponse: FormRequestResponse;
  getEditEstimatedIndemnityOnClaim: FormRequestResponse;
  getEditFarmerOnDocumentFormResponse: FormRequestResponse;
  getEditFinancialResponsibleOnDocumentFormResponse: FormRequestResponse;
  getEditInspectionOnFormResponse: FormRequestResponse;
  getEditIntegrationSettingsFormResponse: FormRequestResponse;
  getEditLeadOnFormResponse: FormRequestResponse;
  getEditMeetingOnObjectFormResponse: FormRequestResponse;
  getEditObjectFormResponse: Scalars['String']['output'];
  getEditPaymentDataOnDocumentFormResponse: FormRequestResponse;
  getEditPaymentOnDocumentFormResponse: FormRequestResponse;
  getEditPolicyOnDocumentFormResponse: FormRequestResponse;
  getEditPropertyOnDocumentFormResponse: FormRequestResponse;
  getEditProposalOnDocumentFormResponse: FormRequestResponse;
  getEditReportFileOnInspection: FormRequestResponse;
  getEditResultOnDocumentFormResponse: FormRequestResponse;
  getEditSignedProposalOnFormResponse: FormRequestResponse;
  getFormResponse?: Maybe<FormResponse>;
  getMany2XOptions: Array<FormDataOptions>;
  getNfeUploadFormResponse: FormRequestResponse;
  getShareToken?: Maybe<Scalars['String']['output']>;
  getTwilioConversations: Array<TwilioConversation>;
  getTwilioMediaUrl: Scalars['String']['output'];
  getTwilioWAMessages: TwilioConversationData;
  inspection?: Maybe<Inspection>;
  integrationSetting: IntegrationSettings;
  integrationSettings: Array<IntegrationSettings>;
  lead?: Maybe<Lead>;
  leads?: Maybe<Array<Maybe<Lead>>>;
  modelTasks: Array<Task>;
  notes: Array<Note>;
  notifications: Array<NotificationResponse>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryCountDocumentsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
};


export type QueryCountLeadsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>>>>;
};


export type QueryCountUsersArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>>>>;
};


export type QueryDocumentArgs = {
  docId: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};


export type QueryGetCancelPolicyOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetComplementaryDataFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetCreateClaimOnFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateInspectionOnFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateIntegrationSettingsFormResponseArgs = {
  formId: Scalars['String']['input'];
};


export type QueryGetCreateMeetingOnObjectFormResponseArgs = {
  parentId: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryGetCreateObjectFormResponseArgs = {
  formId: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
  service: Services;
};


export type QueryGetCreatePaymentOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreatePolicyOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateProposalOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateResultOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetCreateSignedProposalOnFormResponseArgs = {
  proposalResultId: Scalars['String']['input'];
};


export type QueryGetDocumentRejectionFormResponseArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetDocumentsDashboardCountersArgs = {
  filter?: InputMaybe<DocumentsFilterInput>;
};


export type QueryGetDocumentsDashboardTotalValuesArgs = {
  input: DashboardTotalValueDateRange;
};


export type QueryGetEditBillsOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditClaimOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditConclusionLetterOnClaimArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditContestationLetterOnClaimArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditCropOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditEstimatedIndemnityOnClaimArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditFarmerOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditFinancialResponsibleOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditInspectionOnFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditIntegrationSettingsFormResponseArgs = {
  formId: Scalars['String']['input'];
  listIndex?: InputMaybe<Scalars['Float']['input']>;
  objectId: Scalars['String']['input'];
};


export type QueryGetEditLeadOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditMeetingOnObjectFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditObjectFormResponseArgs = {
  formId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  objectId: Scalars['String']['input'];
  service: Services;
};


export type QueryGetEditPaymentDataOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPaymentOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPolicyOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditPropertyOnDocumentFormResponseArgs = {
  documentId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type QueryGetEditProposalOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditReportFileOnInspectionArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditResultOnDocumentFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetEditSignedProposalOnFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetFormResponseArgs = {
  formResponseId: Scalars['String']['input'];
};


export type QueryGetMany2XOptionsArgs = {
  currentValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain: Scalars['JSON']['input'];
  searchTerm: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryGetNfeUploadFormResponseArgs = {
  objectId: Scalars['String']['input'];
};


export type QueryGetShareTokenArgs = {
  objectId: Scalars['String']['input'];
  service: Services;
};


export type QueryGetTwilioMediaUrlArgs = {
  mediaId: Scalars['String']['input'];
};


export type QueryGetTwilioWaMessagesArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryInspectionArgs = {
  inspectionId: Scalars['String']['input'];
};


export type QueryIntegrationSettingArgs = {
  settingId: Scalars['String']['input'];
};


export type QueryLeadArgs = {
  leadId: Scalars['String']['input'];
};


export type QueryLeadsArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};


export type QueryModelTasksArgs = {
  objectId?: InputMaybe<Scalars['String']['input']>;
  serviceName: Services;
};


export type QueryNotesArgs = {
  docId: Scalars['String']['input'];
  serviceName: Services;
};


export type QueryNotificationsArgs = {
  serviceName: Services;
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['MongoSortQuery']['input']>;
};

export enum RatingScale {
  Outstanding = 'outstanding',
  Poor = 'poor',
  Satisfactory = 'satisfactory',
  Unsatisfactory = 'unsatisfactory',
  VerySatisfactory = 'verySatisfactory'
}

export type Result = {
  __typename?: 'Result';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  amounts?: Maybe<ResultAmounts>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  basicCoverageType?: Maybe<BasicCoverageTypes>;
  coverages?: Maybe<Array<ResultCoverage>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  guaranteedProductivity?: Maybe<Scalars['Float']['output']>;
  insuranceTypeGroup?: Maybe<InsuranceTypeGroupEnum>;
  name?: Maybe<Scalars['String']['output']>;
  proposalFile?: Maybe<File>;
  provider?: Maybe<PropostaProviders>;
  referenceLocation?: Maybe<Scalars['String']['output']>;
  sackValue?: Maybe<Scalars['Float']['output']>;
  signedProposalFile?: Maybe<File>;
  status?: Maybe<ResultStatus>;
  tags?: Maybe<Array<Maybe<ResultTags>>>;
  type?: Maybe<ResultTypes>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ResultAmounts = {
  __typename?: 'ResultAmounts';
  federalSubvention?: Maybe<Scalars['Float']['output']>;
  finalPremium?: Maybe<Scalars['Float']['output']>;
  lmi?: Maybe<Scalars['Float']['output']>;
  maxPayments?: Maybe<Scalars['Int']['output']>;
  stateSubvention?: Maybe<Scalars['Float']['output']>;
  totalPremium?: Maybe<Scalars['Float']['output']>;
};

export type ResultCoverage = {
  __typename?: 'ResultCoverage';
  coverageEventIds: Array<Scalars['ObjectId']['output']>;
  coverageEvents?: Maybe<Array<CoverageEvent>>;
  coverageTags?: Maybe<CoverageTags>;
  lmi?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
};

export enum ResultStatus {
  Approved = 'approved',
  Deleted = 'deleted',
  Error = 'error',
  Pending = 'pending',
  Sent = 'sent'
}

export enum ResultTags {
  HighestProductivity = 'highestProductivity',
  HighestSackValue = 'highestSackValue',
  LowestCost = 'lowestCost'
}

export enum ResultTypes {
  Proposal = 'proposal',
  Quotation = 'quotation',
  Simulation = 'simulation'
}

export enum Services {
  Banks = 'banks',
  BridgeCommunications = 'bridgeCommunications',
  Calculations = 'calculations',
  Claims = 'claims',
  Contacts = 'contacts',
  CoverageEvents = 'coverageEvents',
  Crops = 'crops',
  Cultures = 'cultures',
  Documents = 'documents',
  Email = 'email',
  EmissionInstitutions = 'emissionInstitutions',
  EquipmentBrands = 'equipmentBrands',
  EquipmentTypes = 'equipmentTypes',
  Equipments = 'equipments',
  Forms = 'forms',
  Inspections = 'inspections',
  Leads = 'leads',
  Meetings = 'meetings',
  Notes = 'notes',
  Notifications = 'notifications',
  Payments = 'payments',
  Policies = 'policies',
  Professions = 'professions',
  Properties = 'properties',
  PropertyActivities = 'propertyActivities',
  Results = 'results',
  SpecialOperations = 'specialOperations',
  Tasks = 'tasks',
  TwilioWaMessages = 'twilioWAMessages',
  Users = 'users'
}

export type SpecialOperation = {
  __typename?: 'SpecialOperation';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type StatusDashboardCounters = {
  __typename?: 'StatusDashboardCounters';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  conversationUpdated?: Maybe<ConversationUpdated>;
  msgSeenUpdated?: Maybe<MsgSeenUpdated>;
};

export enum SubscriptionEvents {
  ConversationUpdated = 'conversationUpdated',
  MsgSeenUpdated = 'msgSeenUpdated'
}

export enum SubventionType {
  Federal = 'federal',
  State = 'state'
}

export type SwissSettings = {
  __typename?: 'SwissSettings';
  plantDate?: Maybe<Scalars['Date']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  soilTypeCode?: Maybe<Scalars['String']['output']>;
  stateSettings?: Maybe<Array<SwissStateSettings>>;
  systemCode?: Maybe<Scalars['String']['output']>;
  valRiscoNomeado?: Maybe<Scalars['Float']['output']>;
  valSaca?: Maybe<Scalars['Float']['output']>;
};

export type SwissStateSettings = {
  __typename?: 'SwissStateSettings';
  states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  valCusteio: Scalars['Float']['output'];
};

export type Task = {
  __typename?: 'Task';
  dateDue: Scalars['Date']['output'];
  docId: Scalars['ObjectId']['output'];
  message: Scalars['String']['output'];
  modelName: Scalars['String']['output'];
  originInfo?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<User>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
};

export enum TransactionalEvents {
  ApprovedQuotation = 'approvedQuotation',
  ApprovedRegister = 'approvedRegister',
  ComplementaryData = 'complementaryData',
  InvoicesForm = 'invoicesForm',
  PendingQuotation = 'pendingQuotation',
  QuotationResults = 'quotationResults',
  UploadedPolicy = 'uploadedPolicy',
  UploadedProposal = 'uploadedProposal'
}

export type TwilioConversation = {
  __typename?: 'TwilioConversation';
  contact: Contact;
  lastMsg: TwilioWaMessage;
  notSeenCount?: Maybe<Scalars['Int']['output']>;
};

export type TwilioConversationData = {
  __typename?: 'TwilioConversationData';
  contact: Contact;
  documentIds: Array<Scalars['String']['output']>;
  messages: Array<TwilioWaMessage>;
};

export type TwilioMedia = {
  __typename?: 'TwilioMedia';
  externalId: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
};

export type TwilioMediaInput = {
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type TwilioWaMessage = {
  __typename?: 'TwilioWAMessage';
  _id: Scalars['ObjectId']['output'];
  content?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  medias?: Maybe<Array<TwilioMedia>>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  status: TwilioWaMsgStatus;
  templateName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum TwilioWaMsgStatus {
  Delivered = 'delivered',
  Enqueued = 'enqueued',
  Failed = 'failed',
  Pending = 'pending',
  Read = 'read',
  Sent = 'sent'
}

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  civilState?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cultureIds?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Array<InsuranceDocument>>;
  email?: Maybe<Scalars['String']['output']>;
  finishedCourse?: Maybe<Scalars['Boolean']['output']>;
  indicators?: Maybe<Array<UserIndicator>>;
  meetingIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  meetings?: Maybe<Array<Meeting>>;
  nextCallDate?: Maybe<Scalars['Date']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<RatingScale>;
  responsible?: Maybe<User>;
  responsibleId?: Maybe<Scalars['ObjectId']['output']>;
  rg?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRoles>;
  signedDate?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserIndicator = {
  __typename?: 'UserIndicator';
  _id?: Maybe<Scalars['String']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  totalCommission?: Maybe<Scalars['Float']['output']>;
  totalPremium?: Maybe<Scalars['Float']['output']>;
};

export enum UserRating {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum UserRoles {
  Admin = 'admin',
  Consultant = 'consultant',
  Cooperative = 'cooperative',
  Organization = 'organization',
  Resale = 'resale'
}

export enum UserStatus {
  Active = 'active',
  Approved = 'approved',
  Registered = 'registered',
  Rejected = 'rejected'
}

export type SetIndemnityPaidMutationVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type SetIndemnityPaidMutation = { __typename?: 'Mutation', setIndemnityPaid?: boolean | null };

export type GetOrCreateContactByPhoneMutationVariables = Exact<{
  mobilePhone: Scalars['String']['input'];
}>;


export type GetOrCreateContactByPhoneMutation = { __typename?: 'Mutation', getOrCreateContactByPhone: { __typename?: 'Contact', _id?: string | null } };

export type SelectResultsMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SelectResultsMutation = { __typename?: 'Mutation', selectResults: boolean };

export type SetQuotationCommentMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SetQuotationCommentMutation = { __typename?: 'Mutation', setQuotationComment: boolean };

export type ApproveSimulationResultMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
}>;


export type ApproveSimulationResultMutation = { __typename?: 'Mutation', approveSimulationResult: boolean };

export type RecedeDocumentStageMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  docStatus: DocumentStatus;
}>;


export type RecedeDocumentStageMutation = { __typename?: 'Mutation', recedeDocumentStageToSimulation: boolean };

export type AddCommercialResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddCommercialResponsibleMutation = { __typename?: 'Mutation', addCommercialResponsibleToDocument: boolean };

export type AddOperationalResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddOperationalResponsibleMutation = { __typename?: 'Mutation', addOperationalResponsibleToDocument: boolean };

export type AddClaimResponsibleMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddClaimResponsibleMutation = { __typename?: 'Mutation', addClaimResponsibleToDocument: boolean };

export type AddOriginatorMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  originatorId: Scalars['String']['input'];
}>;


export type AddOriginatorMutation = { __typename?: 'Mutation', addOriginatorToDocument: boolean };

export type ArchiveDocumentMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ArchiveDocumentMutation = { __typename?: 'Mutation', archiveDocument: boolean };

export type FinishSimulationMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type FinishSimulationMutation = { __typename?: 'Mutation', finishSimulation: boolean };

export type RedoQuotationsMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type RedoQuotationsMutation = { __typename?: 'Mutation', redoQuotations: boolean };

export type DeleteSimulationResultMutationVariables = Exact<{
  resultId: Scalars['String']['input'];
}>;


export type DeleteSimulationResultMutation = { __typename?: 'Mutation', deleteSimulationResult: boolean };

export type SetPaymentDoneMutationVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;


export type SetPaymentDoneMutation = { __typename?: 'Mutation', setPaymentDone: boolean };

export type SendQuotationMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
}>;


export type SendQuotationMutation = { __typename?: 'Mutation', sendQuotation: boolean };

export type SendProposalMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
}>;


export type SendProposalMutation = { __typename?: 'Mutation', sendProposal: boolean };

export type SendPolicyMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  silent: Scalars['Boolean']['input'];
}>;


export type SendPolicyMutation = { __typename?: 'Mutation', sendPolicy: boolean };

export type ArchiveProposalMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ArchiveProposalMutation = { __typename?: 'Mutation', archiveProposal: boolean };

export type DeletePaymentMutationVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: boolean };

export type RecommendSimulationResultMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
}>;


export type RecommendSimulationResultMutation = { __typename?: 'Mutation', recommendSimulationResult: boolean };

export type RemoveRecommendedSimulationResultMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type RemoveRecommendedSimulationResultMutation = { __typename?: 'Mutation', removeRecommendedSimulationResult: boolean };

export type CreateFormResponseMutationVariables = Exact<{
  formId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type CreateFormResponseMutation = { __typename?: 'Mutation', createFormResponse: { __typename?: 'FormResponse', _id?: string | null } };

export type UpsertFormFieldMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}>;


export type UpsertFormFieldMutation = { __typename?: 'Mutation', upsertFormField: Array<any | null> };

export type SubmitFormResponseMutationVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type SubmitFormResponseMutation = { __typename?: 'Mutation', submitFormResponse: any };

export type SendTransactionalEventMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  event: TransactionalEvents;
}>;


export type SendTransactionalEventMutation = { __typename?: 'Mutation', sendTransactionalEvent: any };

export type AddCommercialResponsibleLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddCommercialResponsibleLeadMutation = { __typename?: 'Mutation', addCommercialResponsibleToLead: boolean };

export type AddTechnicalResponsibleLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddTechnicalResponsibleLeadMutation = { __typename?: 'Mutation', addTechnicalResponsibleToLead: boolean };

export type ChangeLeadStatusMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  status: LeadStatus;
}>;


export type ChangeLeadStatusMutation = { __typename?: 'Mutation', changeLeadStatus: boolean };

export type RateLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  rating: RatingScale;
}>;


export type RateLeadMutation = { __typename?: 'Mutation', rateLead: boolean };

export type AddCommentToLeadMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type AddCommentToLeadMutation = { __typename?: 'Mutation', addCommentToLead: boolean };

export type CreateNoteMutationVariables = Exact<{
  docId: Scalars['String']['input'];
  authorId: Scalars['String']['input'];
  serviceName: Services;
  text: Scalars['String']['input'];
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: any };

export type RetrySimulationResultMutationVariables = Exact<{
  resultId: Scalars['String']['input'];
}>;


export type RetrySimulationResultMutation = { __typename?: 'Mutation', retrySimulationResult: boolean };

export type SendTwilioWaMessageMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  files: Array<TwilioMediaInput> | TwilioMediaInput;
}>;


export type SendTwilioWaMessageMutation = { __typename?: 'Mutation', sendTwilioWAMessage: boolean };

export type AddResponsibleToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  responsibleId: Scalars['String']['input'];
}>;


export type AddResponsibleToUserMutation = { __typename?: 'Mutation', addResponsibleToUser: boolean };

export type AddRatingToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  rating: RatingScale;
}>;


export type AddRatingToUserMutation = { __typename?: 'Mutation', addRatingToUser: boolean };

export type AddCommentToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type AddCommentToUserMutation = { __typename?: 'Mutation', addCommentToUser: boolean };

export type AddCultureToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  cultureIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
}>;


export type AddCultureToUserMutation = { __typename?: 'Mutation', addCultureToUser: boolean };

export type AddCourseToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  finishedCourse: Scalars['Boolean']['input'];
}>;


export type AddCourseToUserMutation = { __typename?: 'Mutation', addCourseToUser: boolean };

export type GetCreateClaimOnFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateClaimOnFormResponseQuery = { __typename?: 'Query', getCreateClaimOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditClaimOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditClaimOnFormResponseQuery = { __typename?: 'Query', getEditClaimOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditConclusionLetterOnClaimQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditConclusionLetterOnClaimQuery = { __typename?: 'Query', getEditConclusionLetterOnClaim: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditEstimatedIndemnityOnClaimQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditEstimatedIndemnityOnClaimQuery = { __typename?: 'Query', getEditEstimatedIndemnityOnClaim: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditContestationLetterOnClaimQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditContestationLetterOnClaimQuery = { __typename?: 'Query', getEditContestationLetterOnClaim: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditFarmerOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditFarmerOnDocumentFormResponseQuery = { __typename?: 'Query', getEditFarmerOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditFinancialResponsibleOnDocumentFormResponseQuery = { __typename?: 'Query', getEditFinancialResponsibleOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditCropOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditCropOnDocumentFormResponseQuery = { __typename?: 'Query', getEditCropOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ListDocumentsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
}>;


export type ListDocumentsQuery = { __typename?: 'Query', documents?: Array<{ __typename?: 'InsuranceDocument', _id?: string | null, stage?: DocumentStages | null, status?: DocumentStatus | null, createdAt?: any | null, commercialResponsibleId?: string | null, operationalResponsibleId?: string | null, originatorId?: string | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, commercialResponsible?: { __typename?: 'User', nome?: string | null } | null, operationalResponsible?: { __typename?: 'User', nome?: string | null } | null, originator?: { __typename?: 'User', nome?: string | null } | null, farmer?: { __typename?: 'Contact', name?: string | null } | null, crop?: { __typename?: 'Crop', cultureName?: string | null, area?: number | null, culture?: { __typename?: 'Culture', name?: string | null } | null } | null, property?: { __typename?: 'Property', address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null } | null } | null> | null };

export type CountDocumentsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>> | InputMaybe<Array<InputMaybe<DocumentsFilterInput>> | InputMaybe<DocumentsFilterInput>>;
}>;


export type CountDocumentsQuery = { __typename?: 'Query', countDocuments?: number | null };

export type GetComplementaryDataFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetComplementaryDataFormResponseQuery = { __typename?: 'Query', getComplementaryDataFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetNfeUploadFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetNfeUploadFormResponseQuery = { __typename?: 'Query', getNfeUploadFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPaymentDataOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPaymentDataOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPaymentDataOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetDocumentRejectionFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetDocumentRejectionFormResponseQuery = { __typename?: 'Query', getDocumentRejectionFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetDocumentsDashboardCountersQueryVariables = Exact<{
  filter?: InputMaybe<DocumentsFilterInput>;
}>;


export type GetDocumentsDashboardCountersQuery = { __typename?: 'Query', getDocumentsDashboardCounters?: Array<{ __typename?: 'CategoryDashboardCounters', count: number, value: string, statuses?: Array<{ __typename?: 'StatusDashboardCounters', count: number, value: string }> | null }> | null };

export type GetDocumentsDashboardTotalValuesQueryVariables = Exact<{
  input: DashboardTotalValueDateRange;
}>;


export type GetDocumentsDashboardTotalValuesQuery = { __typename?: 'Query', getDocumentsDashboardTotalValues?: Array<{ __typename?: 'DashboardTotalValue', category: string, value: number }> | null };

export type GetDocumentDetailsQueryVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type GetDocumentDetailsQuery = { __typename?: 'Query', document?: { __typename?: 'InsuranceDocument', _id?: string | null, createdAt?: any | null, updatedAt?: any | null, stage?: DocumentStages | null, status?: DocumentStatus | null, provider?: PropostaProviders | null, selectedResultIds?: Array<string> | null, recommendedSimulationResultId?: string | null, justificationMessage?: string | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, commercialResponsibleId?: string | null, operationalResponsibleId?: string | null, claimResponsibleId?: string | null, originatorId?: string | null, premium?: number | null, archived?: boolean | null, proposalResultId?: string | null, rejectReason?: { __typename?: 'DocumentReject', other?: string | null, rejectReason: DocumentRejectReason } | null, visitPerson?: { __typename?: 'Contact', name?: string | null } | null, costNFFiles?: Array<{ __typename?: 'File', fileName?: string | null, fileKey?: string | null }> | null, kmlFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, crop?: { __typename?: 'Crop', _id?: string | null, area?: number | null, cultureName?: string | null, harvestStartDate?: any | null, harvestEndDate?: any | null, manualCulture?: string | null, compositionType?: any | null, cropYear?: string | null, culture?: { __typename?: 'Culture', name?: string | null } | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null, kmlFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, seedType?: string | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null }> | null } | null, farmer?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: string | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null, property?: { __typename?: 'Property', _id?: string | null, accessInstructions?: string | null, entranceLocation?: any | null, name?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null> | null } | null, failedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, error?: string | null, provider?: PropostaProviders | null } | null> | null, validSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, status?: ResultStatus | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, tags?: Array<ResultTags | null> | null, referenceLocation?: string | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null, maxPayments?: number | null } | null } | null> | null, simulationResults?: Array<{ __typename?: 'Result', _id?: string | null, externalId?: string | null, status?: ResultStatus | null, error?: string | null, name?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, referenceLocation?: string | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null, maxPayments?: number | null } | null } | null> | null, selectedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, tags?: Array<ResultTags | null> | null, referenceLocation?: string | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> | null } | null> | null, proposalResult?: { __typename?: 'Result', _id?: string | null, externalId?: string | null, name?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, proposalFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, signedProposalFile?: { __typename?: 'File', _id?: string | null, fileName?: string | null, fileKey?: string | null } | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageTags?: CoverageTags | null }> | null } | null, beneficiary?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: string | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null, allowedVisitPeople?: Array<{ __typename?: 'Contact', name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null }> | null, policy?: { __typename?: 'Policy', _id: string, endDate: any, startDate: any, externalId: string, cancellationReason?: PolicyRejectReason | null, billsFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, policyFile: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } } | null, paymentData?: { __typename?: 'PaymentData', method?: PaymentMethods | null, responsibleId?: string | null, installments?: number | null, accountData?: { __typename?: 'AccountData', bank?: string | null, agency?: string | null, account?: string | null } | null, responsible?: { __typename?: 'Contact', _id?: string | null, name?: string | null, cpfCnpj?: string | null, mobilePhone?: string | null, email?: string | null, rg?: string | null, emissionInstitution?: string | null, expeditionDate?: any | null, civilState?: string | null, gender?: string | null, birthDate?: any | null, profession?: string | null, documentFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, addressProofFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, number?: string | null, complement?: string | null, cep?: string | null } | null } | null } | null, payments?: Array<{ __typename?: 'Payment', _id: string, responsibleId: string, provider: PropostaProviders, name: string, dateDue: any, amount: number, status: PaymentStatus, subventionType?: SubventionType | null, billFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null }> | null, archivedProposals?: Array<{ __typename?: 'Result', _id?: string | null, externalId?: string | null, provider?: PropostaProviders | null, basicCoverageType?: BasicCoverageTypes | null, type?: ResultTypes | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, guaranteedProductivity?: number | null }> | null, claims?: Array<{ __typename?: 'Claim', _id: string, name: string, externalId: string, status: ClaimStatus, events: Array<ClaimEvent>, plots?: Array<string> | null, coverages: Array<string>, startDate: any, endDate?: any | null, lossEstimate: LossEstimate, comment?: string | null, createdAt: any, protocolNumber?: string | null, noticeDate: any, indemnityAmount?: number | null, indemnityPaymentDate?: any | null, estimatedIndemnity?: number | null, contestationProtocolNumber?: number | null, dateOfReanalysis?: any | null, reportFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null, contestationLetterFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null }> | null, inspections?: Array<{ __typename?: 'Inspection', _id: string, documentId: string, status: InspectionStatus, type: InspectionType, date: any, regulatoryAgency: string, claims?: Array<{ __typename?: 'Claim', name: string } | null> | null, inspector?: { __typename?: 'Contact', name?: string | null, mobilePhone?: string | null } | null, reportFile?: { __typename?: 'File', fileName?: string | null, fileKey?: string | null } | null }> | null } | null };

export type GetDirectDocumentDetailsQueryVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type GetDirectDocumentDetailsQuery = { __typename?: 'Query', document?: { __typename?: 'InsuranceDocument', _id?: string | null, stage?: DocumentStages | null, status?: DocumentStatus | null, justificationMessage?: string | null, recommendedSimulationResultId?: string | null, insuranceTypeGroup?: InsuranceTypeGroupEnum | null, premium?: number | null, createdAt?: any | null, specialOperationId?: string | null, crop?: { __typename?: 'Crop', area?: number | null, cultureName?: string | null, manualCulture?: string | null, culture?: { __typename?: 'Culture', name?: string | null } | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null, farmer?: { __typename?: 'Contact', name?: string | null, cpfCnpj?: string | null } | null, property?: { __typename?: 'Property', name?: string | null, plots?: Array<{ __typename?: 'Plot', name?: string | null, area?: number | null, plantDate?: any | null, plantMethod?: string | null, soilType?: any | null, irrigated?: boolean | null, cropYear?: string | null, plantSpacing?: number | null, lineSpacing?: number | null, cultureDetail?: { __typename?: 'CultureDetail', name?: string | null } | null } | null> | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null } | null } | null, selectedSimulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, sackValue?: number | null, tags?: Array<ResultTags | null> | null, referenceLocation?: string | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> | null } | null> | null, simulationResults?: Array<{ __typename?: 'Result', _id?: string | null, name?: string | null, provider?: PropostaProviders | null, status?: ResultStatus | null, basicCoverageType?: BasicCoverageTypes | null, guaranteedProductivity?: number | null, referenceLocation?: string | null, amounts?: { __typename?: 'ResultAmounts', lmi?: number | null, totalPremium?: number | null, maxPayments?: number | null, stateSubvention?: number | null, federalSubvention?: number | null, finalPremium?: number | null } | null, coverages?: Array<{ __typename?: 'ResultCoverage', name?: string | null, lmi?: number | null, premium?: number | null, coverageEvents?: Array<{ __typename?: 'CoverageEvent', _id?: string | null, name: string }> | null }> | null } | null> | null } | null };

export type GetFormResponseQueryVariables = Exact<{
  formResponseId: Scalars['String']['input'];
}>;


export type GetFormResponseQuery = { __typename?: 'Query', getFormResponse?: { __typename?: 'FormResponse', formData?: any | null, formState?: any | null, errors?: any | null } | null };

export type GetCreateObjectFormResponseQueryVariables = Exact<{
  service: Services;
  formId: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;


export type GetCreateObjectFormResponseQuery = { __typename?: 'Query', getCreateObjectFormResponse: string };

export type GetEditObjectFormResponseQueryVariables = Exact<{
  service: Services;
  formId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetEditObjectFormResponseQuery = { __typename?: 'Query', getEditObjectFormResponse: string };

export type GetShareTokenQueryVariables = Exact<{
  service: Services;
  objectId: Scalars['String']['input'];
}>;


export type GetShareTokenQuery = { __typename?: 'Query', getShareToken?: string | null };

export type GetMany2XOptionsQueryVariables = Exact<{
  serviceName: Services;
  domain: Scalars['JSON']['input'];
  searchTerm: Scalars['String']['input'];
  currentValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetMany2XOptionsQuery = { __typename?: 'Query', getMany2XOptions: Array<{ __typename?: 'FormDataOptions', label?: string | null, value: string }> };

export type GetCreateInspectionOnFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateInspectionOnFormResponseQuery = { __typename?: 'Query', getCreateInspectionOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditInspectionOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditInspectionOnFormResponseQuery = { __typename?: 'Query', getEditInspectionOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditReportFileOnInspectionQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditReportFileOnInspectionQuery = { __typename?: 'Query', getEditReportFileOnInspection: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetSwissIntegrationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSwissIntegrationSettingsQuery = { __typename?: 'Query', integrationSettings: Array<{ __typename?: 'IntegrationSettings', _id: string, culture?: { __typename?: 'Culture', name?: string | null } | null, swiss?: { __typename?: 'SwissSettings', productCode?: string | null, systemCode?: string | null, soilTypeCode?: string | null, valRiscoNomeado?: number | null, valSaca?: number | null, plantDate?: any | null } | null }> };

export type GetSwissStateIntegrationSettingsQueryVariables = Exact<{
  settingId: Scalars['String']['input'];
}>;


export type GetSwissStateIntegrationSettingsQuery = { __typename?: 'Query', integrationSetting: { __typename?: 'IntegrationSettings', _id: string, swiss?: { __typename?: 'SwissSettings', stateSettings?: Array<{ __typename?: 'SwissStateSettings', states?: Array<string | null> | null, valCusteio: number }> | null } | null } };

export type GetCreateIntegrationSettingsFormResponseQueryVariables = Exact<{
  formId: Scalars['String']['input'];
}>;


export type GetCreateIntegrationSettingsFormResponseQuery = { __typename?: 'Query', getCreateIntegrationSettingsFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type GetEditIntegrationSettingsFormResponseQueryVariables = Exact<{
  formId: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  listIndex?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetEditIntegrationSettingsFormResponseQuery = { __typename?: 'Query', getEditIntegrationSettingsFormResponse: { __typename?: 'FormRequestResponse', formResponseId: string, formId: string } };

export type ListLeadsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>> | InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>;
}>;


export type ListLeadsQuery = { __typename?: 'Query', leads?: Array<{ __typename?: 'Lead', _id?: string | null, area?: number | null, type?: LeadTypes | null, status?: LeadStatus | null, name?: string | null, createdAt?: any | null, rating?: RatingScale | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, cep?: string | null } | null, cultures?: Array<{ __typename?: 'Culture', _id?: string | null, name?: string | null }> | null } | null> | null };

export type CountLeadsQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>> | InputMaybe<Array<InputMaybe<LeadFiltersInput>> | InputMaybe<LeadFiltersInput>>;
}>;


export type CountLeadsQuery = { __typename?: 'Query', countLeads?: number | null };

export type GetLeadDetailsQueryVariables = Exact<{
  leadId: Scalars['String']['input'];
}>;


export type GetLeadDetailsQuery = { __typename?: 'Query', lead?: { __typename?: 'Lead', _id?: string | null, type?: LeadTypes | null, status?: LeadStatus | null, name?: string | null, area?: number | null, comments?: string | null, createdAt?: any | null, email?: string | null, linkedin?: string | null, meetingIds?: Array<string> | null, phone?: string | null, rating?: RatingScale | null, commercialResponsibleId?: string | null, technicalResponsibleId?: string | null, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null } | null, cultures?: Array<{ __typename?: 'Culture', _id?: string | null, name?: string | null }> | null, meetings?: Array<{ __typename?: 'Meeting', _id?: string | null, status: MeetingStatus, date: any, topic: MeetingTopics, comment?: string | null, attachment?: any | null, responsible?: { __typename?: 'User', nome?: string | null } | null }> | null } | null };

export type GetEditLeadOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditLeadOnFormResponseQuery = { __typename?: 'Query', getEditLeadOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateMeetingOnObjectFormResponseQueryVariables = Exact<{
  parentId: Scalars['String']['input'];
  serviceName: Services;
}>;


export type GetCreateMeetingOnObjectFormResponseQuery = { __typename?: 'Query', getCreateMeetingOnObjectFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditMeetingOnObjectFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditMeetingOnObjectFormResponseQuery = { __typename?: 'Query', getEditMeetingOnObjectFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type NotesQueryVariables = Exact<{
  docId: Scalars['String']['input'];
  serviceName: Services;
}>;


export type NotesQuery = { __typename?: 'Query', notes: Array<{ __typename?: 'Note', text?: string | null, createdAt?: any | null, serviceName?: Services | null, authorId: { __typename?: 'User', nome?: string | null } }> };

export type NotificationsQueryVariables = Exact<{
  serviceName: Services;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'NotificationResponse', notificationDate: any, dateNotifications: Array<{ __typename?: 'ObjectNotifications', notificationGroup: string, groupNotifications: Array<{ __typename?: 'Notification', objectId: string, serviceName: string, createdAt: any, text: string, originInfo: string, author?: { __typename?: 'User', nome?: string | null } | null }> }> }> };

export type GetCreatePaymentOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreatePaymentOnDocumentFormResponseQuery = { __typename?: 'Query', getCreatePaymentOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPaymentOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPaymentOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPaymentOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreatePolicyOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreatePolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getCreatePolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPolicyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditPolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditBillsOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditBillsOnDocumentFormResponseQuery = { __typename?: 'Query', getEditBillsOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCancelPolicyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetCancelPolicyOnDocumentFormResponseQuery = { __typename?: 'Query', getCancelPolicyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditPropertyOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type GetEditPropertyOnDocumentFormResponseQuery = { __typename?: 'Query', getEditPropertyOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateProposalOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateProposalOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateProposalOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateResultOnDocumentFormResponseQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type GetCreateResultOnDocumentFormResponseQuery = { __typename?: 'Query', getCreateResultOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditProposalOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditProposalOnDocumentFormResponseQuery = { __typename?: 'Query', getEditProposalOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditResultOnDocumentFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditResultOnDocumentFormResponseQuery = { __typename?: 'Query', getEditResultOnDocumentFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetCreateSignedProposalOnFormResponseQueryVariables = Exact<{
  proposalResultId: Scalars['String']['input'];
}>;


export type GetCreateSignedProposalOnFormResponseQuery = { __typename?: 'Query', getCreateSignedProposalOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type GetEditSignedProposalOnFormResponseQueryVariables = Exact<{
  objectId: Scalars['String']['input'];
}>;


export type GetEditSignedProposalOnFormResponseQuery = { __typename?: 'Query', getEditSignedProposalOnFormResponse: { __typename?: 'FormRequestResponse', formId: string, formResponseId: string } };

export type ModelTasksQueryVariables = Exact<{
  serviceName: Services;
  objectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ModelTasksQuery = { __typename?: 'Query', modelTasks: Array<{ __typename?: 'Task', modelName: string, message: string, docId: string, dateDue: any, originInfo?: string | null, responsible?: { __typename?: 'User', nome?: string | null } | null }> };

export type GetTwilioWaMessagesQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetTwilioWaMessagesQuery = { __typename?: 'Query', getTwilioWAMessages: { __typename?: 'TwilioConversationData', documentIds: Array<string>, messages: Array<{ __typename?: 'TwilioWAMessage', content?: string | null, sentAt?: any | null, createdAt: any, type: string, conversationId: string, templateName?: string | null, _id: string, status: TwilioWaMsgStatus, medias?: Array<{ __typename?: 'TwilioMedia', externalId: string, fileName?: string | null }> | null }>, contact: { __typename?: 'Contact', name?: string | null, mobilePhone?: string | null } } };

export type GetTwilioMediaUrlQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type GetTwilioMediaUrlQuery = { __typename?: 'Query', getTwilioMediaUrl: string };

export type GetTwilioConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTwilioConversationsQuery = { __typename?: 'Query', getTwilioConversations: Array<{ __typename?: 'TwilioConversation', notSeenCount?: number | null, lastMsg: { __typename?: 'TwilioWAMessage', content?: string | null, sentAt?: any | null, medias?: Array<{ __typename?: 'TwilioMedia', externalId: string, fileName?: string | null }> | null }, contact: { __typename?: 'Contact', _id?: string | null, name?: string | null, mobilePhone?: string | null } }> };

export type ListUsersQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>> | InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>;
}>;


export type ListUsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', _id?: string | null, role?: UserRoles | null, status?: UserStatus | null, nome?: string | null, email?: string | null, city?: string | null, state?: string | null, disabled?: boolean | null, profession?: string | null, signedDate?: any | null, responsibleId?: string | null, createdAt?: any | null } | null> | null };

export type CountUsersQueryVariables = Exact<{
  filter: Array<InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>> | InputMaybe<Array<InputMaybe<PartnersFiltersInput>> | InputMaybe<PartnersFiltersInput>>;
}>;


export type CountUsersQuery = { __typename?: 'Query', countUsers?: number | null };

export type GetUserDetailsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserDetailsQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, role?: UserRoles | null, status?: UserStatus | null, signedDate?: any | null, createdAt?: any | null, disabled?: boolean | null, username?: string | null, nome?: string | null, email?: string | null, phone?: string | null, cpf?: string | null, rg?: string | null, civilState?: string | null, cep?: string | null, city?: string | null, state?: string | null, profession?: string | null, rating?: RatingScale | null, comments?: string | null, cultureIds?: Array<string | null> | null, finishedCourse?: boolean | null, responsible?: { __typename?: 'User', _id?: string | null, nome?: string | null } | null, meetings?: Array<{ __typename?: 'Meeting', _id?: string | null, status: MeetingStatus, responsibleId: string, date: any, topic: MeetingTopics, comment?: string | null, attachment?: any | null, responsible?: { __typename?: 'User', nome?: string | null } | null }> | null, indicators?: Array<{ __typename?: 'UserIndicator', _id?: string | null, totalArea?: number | null, totalPremium?: number | null, totalCommission?: number | null }> | null } | null };

export type GetUserIndicatorsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserIndicatorsQuery = { __typename?: 'Query', user?: { __typename?: 'User', indicators?: Array<{ __typename?: 'UserIndicator', _id?: string | null, totalArea?: number | null, totalPremium?: number | null, totalCommission?: number | null }> | null } | null };

export type OnConversationUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnConversationUpdatedSubscription = { __typename?: 'Subscription', conversationUpdated?: { __typename?: 'ConversationUpdated', contactId: string, newMsg: boolean } | null };

export type OnMsgSeenUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnMsgSeenUpdatedSubscription = { __typename?: 'Subscription', msgSeenUpdated?: { __typename?: 'MsgSeenUpdated', userId: string } | null };


export const SetIndemnityPaidDocument = gql`
    mutation SetIndemnityPaid($objectId: String!) {
  setIndemnityPaid(objectId: $objectId)
}
    `;
export type SetIndemnityPaidMutationFn = Apollo.MutationFunction<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>;

/**
 * __useSetIndemnityPaidMutation__
 *
 * To run a mutation, you first call `useSetIndemnityPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndemnityPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndemnityPaidMutation, { data, loading, error }] = useSetIndemnityPaidMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useSetIndemnityPaidMutation(baseOptions?: Apollo.MutationHookOptions<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>(SetIndemnityPaidDocument, options);
      }
export type SetIndemnityPaidMutationHookResult = ReturnType<typeof useSetIndemnityPaidMutation>;
export type SetIndemnityPaidMutationResult = Apollo.MutationResult<SetIndemnityPaidMutation>;
export type SetIndemnityPaidMutationOptions = Apollo.BaseMutationOptions<SetIndemnityPaidMutation, SetIndemnityPaidMutationVariables>;
export const GetOrCreateContactByPhoneDocument = gql`
    mutation GetOrCreateContactByPhone($mobilePhone: String!) {
  getOrCreateContactByPhone(mobilePhone: $mobilePhone) {
    _id
  }
}
    `;
export type GetOrCreateContactByPhoneMutationFn = Apollo.MutationFunction<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>;

/**
 * __useGetOrCreateContactByPhoneMutation__
 *
 * To run a mutation, you first call `useGetOrCreateContactByPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateContactByPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateContactByPhoneMutation, { data, loading, error }] = useGetOrCreateContactByPhoneMutation({
 *   variables: {
 *      mobilePhone: // value for 'mobilePhone'
 *   },
 * });
 */
export function useGetOrCreateContactByPhoneMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>(GetOrCreateContactByPhoneDocument, options);
      }
export type GetOrCreateContactByPhoneMutationHookResult = ReturnType<typeof useGetOrCreateContactByPhoneMutation>;
export type GetOrCreateContactByPhoneMutationResult = Apollo.MutationResult<GetOrCreateContactByPhoneMutation>;
export type GetOrCreateContactByPhoneMutationOptions = Apollo.BaseMutationOptions<GetOrCreateContactByPhoneMutation, GetOrCreateContactByPhoneMutationVariables>;
export const SelectResultsDocument = gql`
    mutation SelectResults($docId: String!, $resultsIds: [String!]!) {
  selectResults(docId: $docId, resultsIds: $resultsIds)
}
    `;
export type SelectResultsMutationFn = Apollo.MutationFunction<SelectResultsMutation, SelectResultsMutationVariables>;

/**
 * __useSelectResultsMutation__
 *
 * To run a mutation, you first call `useSelectResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectResultsMutation, { data, loading, error }] = useSelectResultsMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultsIds: // value for 'resultsIds'
 *   },
 * });
 */
export function useSelectResultsMutation(baseOptions?: Apollo.MutationHookOptions<SelectResultsMutation, SelectResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectResultsMutation, SelectResultsMutationVariables>(SelectResultsDocument, options);
      }
export type SelectResultsMutationHookResult = ReturnType<typeof useSelectResultsMutation>;
export type SelectResultsMutationResult = Apollo.MutationResult<SelectResultsMutation>;
export type SelectResultsMutationOptions = Apollo.BaseMutationOptions<SelectResultsMutation, SelectResultsMutationVariables>;
export const SetQuotationCommentDocument = gql`
    mutation SetQuotationComment($docId: String!, $message: String!) {
  setQuotationComment(docId: $docId, message: $message)
}
    `;
export type SetQuotationCommentMutationFn = Apollo.MutationFunction<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>;

/**
 * __useSetQuotationCommentMutation__
 *
 * To run a mutation, you first call `useSetQuotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuotationCommentMutation, { data, loading, error }] = useSetQuotationCommentMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSetQuotationCommentMutation(baseOptions?: Apollo.MutationHookOptions<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>(SetQuotationCommentDocument, options);
      }
export type SetQuotationCommentMutationHookResult = ReturnType<typeof useSetQuotationCommentMutation>;
export type SetQuotationCommentMutationResult = Apollo.MutationResult<SetQuotationCommentMutation>;
export type SetQuotationCommentMutationOptions = Apollo.BaseMutationOptions<SetQuotationCommentMutation, SetQuotationCommentMutationVariables>;
export const ApproveSimulationResultDocument = gql`
    mutation ApproveSimulationResult($docId: String!, $resultId: String!) {
  approveSimulationResult(docId: $docId, resultId: $resultId)
}
    `;
export type ApproveSimulationResultMutationFn = Apollo.MutationFunction<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>;

/**
 * __useApproveSimulationResultMutation__
 *
 * To run a mutation, you first call `useApproveSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSimulationResultMutation, { data, loading, error }] = useApproveSimulationResultMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useApproveSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>(ApproveSimulationResultDocument, options);
      }
export type ApproveSimulationResultMutationHookResult = ReturnType<typeof useApproveSimulationResultMutation>;
export type ApproveSimulationResultMutationResult = Apollo.MutationResult<ApproveSimulationResultMutation>;
export type ApproveSimulationResultMutationOptions = Apollo.BaseMutationOptions<ApproveSimulationResultMutation, ApproveSimulationResultMutationVariables>;
export const RecedeDocumentStageDocument = gql`
    mutation RecedeDocumentStage($docId: String!, $docStatus: DocumentStatus!) {
  recedeDocumentStageToSimulation(docId: $docId, docStatus: $docStatus)
}
    `;
export type RecedeDocumentStageMutationFn = Apollo.MutationFunction<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>;

/**
 * __useRecedeDocumentStageMutation__
 *
 * To run a mutation, you first call `useRecedeDocumentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecedeDocumentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recedeDocumentStageMutation, { data, loading, error }] = useRecedeDocumentStageMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      docStatus: // value for 'docStatus'
 *   },
 * });
 */
export function useRecedeDocumentStageMutation(baseOptions?: Apollo.MutationHookOptions<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>(RecedeDocumentStageDocument, options);
      }
export type RecedeDocumentStageMutationHookResult = ReturnType<typeof useRecedeDocumentStageMutation>;
export type RecedeDocumentStageMutationResult = Apollo.MutationResult<RecedeDocumentStageMutation>;
export type RecedeDocumentStageMutationOptions = Apollo.BaseMutationOptions<RecedeDocumentStageMutation, RecedeDocumentStageMutationVariables>;
export const AddCommercialResponsibleDocument = gql`
    mutation addCommercialResponsible($docId: String!, $responsibleId: String!) {
  addCommercialResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type AddCommercialResponsibleMutationFn = Apollo.MutationFunction<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>;

/**
 * __useAddCommercialResponsibleMutation__
 *
 * To run a mutation, you first call `useAddCommercialResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommercialResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommercialResponsibleMutation, { data, loading, error }] = useAddCommercialResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddCommercialResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>(AddCommercialResponsibleDocument, options);
      }
export type AddCommercialResponsibleMutationHookResult = ReturnType<typeof useAddCommercialResponsibleMutation>;
export type AddCommercialResponsibleMutationResult = Apollo.MutationResult<AddCommercialResponsibleMutation>;
export type AddCommercialResponsibleMutationOptions = Apollo.BaseMutationOptions<AddCommercialResponsibleMutation, AddCommercialResponsibleMutationVariables>;
export const AddOperationalResponsibleDocument = gql`
    mutation addOperationalResponsible($docId: String!, $responsibleId: String!) {
  addOperationalResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type AddOperationalResponsibleMutationFn = Apollo.MutationFunction<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>;

/**
 * __useAddOperationalResponsibleMutation__
 *
 * To run a mutation, you first call `useAddOperationalResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOperationalResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOperationalResponsibleMutation, { data, loading, error }] = useAddOperationalResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddOperationalResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>(AddOperationalResponsibleDocument, options);
      }
export type AddOperationalResponsibleMutationHookResult = ReturnType<typeof useAddOperationalResponsibleMutation>;
export type AddOperationalResponsibleMutationResult = Apollo.MutationResult<AddOperationalResponsibleMutation>;
export type AddOperationalResponsibleMutationOptions = Apollo.BaseMutationOptions<AddOperationalResponsibleMutation, AddOperationalResponsibleMutationVariables>;
export const AddClaimResponsibleDocument = gql`
    mutation addClaimResponsible($docId: String!, $responsibleId: String!) {
  addClaimResponsibleToDocument(docId: $docId, contactId: $responsibleId)
}
    `;
export type AddClaimResponsibleMutationFn = Apollo.MutationFunction<AddClaimResponsibleMutation, AddClaimResponsibleMutationVariables>;

/**
 * __useAddClaimResponsibleMutation__
 *
 * To run a mutation, you first call `useAddClaimResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClaimResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClaimResponsibleMutation, { data, loading, error }] = useAddClaimResponsibleMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddClaimResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<AddClaimResponsibleMutation, AddClaimResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClaimResponsibleMutation, AddClaimResponsibleMutationVariables>(AddClaimResponsibleDocument, options);
      }
export type AddClaimResponsibleMutationHookResult = ReturnType<typeof useAddClaimResponsibleMutation>;
export type AddClaimResponsibleMutationResult = Apollo.MutationResult<AddClaimResponsibleMutation>;
export type AddClaimResponsibleMutationOptions = Apollo.BaseMutationOptions<AddClaimResponsibleMutation, AddClaimResponsibleMutationVariables>;
export const AddOriginatorDocument = gql`
    mutation addOriginator($docId: String!, $originatorId: String!) {
  addOriginatorToDocument(docId: $docId, contactId: $originatorId)
}
    `;
export type AddOriginatorMutationFn = Apollo.MutationFunction<AddOriginatorMutation, AddOriginatorMutationVariables>;

/**
 * __useAddOriginatorMutation__
 *
 * To run a mutation, you first call `useAddOriginatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOriginatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOriginatorMutation, { data, loading, error }] = useAddOriginatorMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      originatorId: // value for 'originatorId'
 *   },
 * });
 */
export function useAddOriginatorMutation(baseOptions?: Apollo.MutationHookOptions<AddOriginatorMutation, AddOriginatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOriginatorMutation, AddOriginatorMutationVariables>(AddOriginatorDocument, options);
      }
export type AddOriginatorMutationHookResult = ReturnType<typeof useAddOriginatorMutation>;
export type AddOriginatorMutationResult = Apollo.MutationResult<AddOriginatorMutation>;
export type AddOriginatorMutationOptions = Apollo.BaseMutationOptions<AddOriginatorMutation, AddOriginatorMutationVariables>;
export const ArchiveDocumentDocument = gql`
    mutation archiveDocument($docId: String!) {
  archiveDocument(docId: $docId)
}
    `;
export type ArchiveDocumentMutationFn = Apollo.MutationFunction<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;

/**
 * __useArchiveDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDocumentMutation, { data, loading, error }] = useArchiveDocumentMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useArchiveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>(ArchiveDocumentDocument, options);
      }
export type ArchiveDocumentMutationHookResult = ReturnType<typeof useArchiveDocumentMutation>;
export type ArchiveDocumentMutationResult = Apollo.MutationResult<ArchiveDocumentMutation>;
export type ArchiveDocumentMutationOptions = Apollo.BaseMutationOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;
export const FinishSimulationDocument = gql`
    mutation finishSimulation($docId: String!) {
  finishSimulation(docId: $docId)
}
    `;
export type FinishSimulationMutationFn = Apollo.MutationFunction<FinishSimulationMutation, FinishSimulationMutationVariables>;

/**
 * __useFinishSimulationMutation__
 *
 * To run a mutation, you first call `useFinishSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSimulationMutation, { data, loading, error }] = useFinishSimulationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useFinishSimulationMutation(baseOptions?: Apollo.MutationHookOptions<FinishSimulationMutation, FinishSimulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSimulationMutation, FinishSimulationMutationVariables>(FinishSimulationDocument, options);
      }
export type FinishSimulationMutationHookResult = ReturnType<typeof useFinishSimulationMutation>;
export type FinishSimulationMutationResult = Apollo.MutationResult<FinishSimulationMutation>;
export type FinishSimulationMutationOptions = Apollo.BaseMutationOptions<FinishSimulationMutation, FinishSimulationMutationVariables>;
export const RedoQuotationsDocument = gql`
    mutation RedoQuotations($docId: String!) {
  redoQuotations(docId: $docId)
}
    `;
export type RedoQuotationsMutationFn = Apollo.MutationFunction<RedoQuotationsMutation, RedoQuotationsMutationVariables>;

/**
 * __useRedoQuotationsMutation__
 *
 * To run a mutation, you first call `useRedoQuotationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedoQuotationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redoQuotationsMutation, { data, loading, error }] = useRedoQuotationsMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useRedoQuotationsMutation(baseOptions?: Apollo.MutationHookOptions<RedoQuotationsMutation, RedoQuotationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedoQuotationsMutation, RedoQuotationsMutationVariables>(RedoQuotationsDocument, options);
      }
export type RedoQuotationsMutationHookResult = ReturnType<typeof useRedoQuotationsMutation>;
export type RedoQuotationsMutationResult = Apollo.MutationResult<RedoQuotationsMutation>;
export type RedoQuotationsMutationOptions = Apollo.BaseMutationOptions<RedoQuotationsMutation, RedoQuotationsMutationVariables>;
export const DeleteSimulationResultDocument = gql`
    mutation DeleteSimulationResult($resultId: String!) {
  deleteSimulationResult(resultId: $resultId)
}
    `;
export type DeleteSimulationResultMutationFn = Apollo.MutationFunction<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>;

/**
 * __useDeleteSimulationResultMutation__
 *
 * To run a mutation, you first call `useDeleteSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSimulationResultMutation, { data, loading, error }] = useDeleteSimulationResultMutation({
 *   variables: {
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useDeleteSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>(DeleteSimulationResultDocument, options);
      }
export type DeleteSimulationResultMutationHookResult = ReturnType<typeof useDeleteSimulationResultMutation>;
export type DeleteSimulationResultMutationResult = Apollo.MutationResult<DeleteSimulationResultMutation>;
export type DeleteSimulationResultMutationOptions = Apollo.BaseMutationOptions<DeleteSimulationResultMutation, DeleteSimulationResultMutationVariables>;
export const SetPaymentDoneDocument = gql`
    mutation SetPaymentDone($paymentId: String!) {
  setPaymentDone(paymentId: $paymentId)
}
    `;
export type SetPaymentDoneMutationFn = Apollo.MutationFunction<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>;

/**
 * __useSetPaymentDoneMutation__
 *
 * To run a mutation, you first call `useSetPaymentDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentDoneMutation, { data, loading, error }] = useSetPaymentDoneMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useSetPaymentDoneMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>(SetPaymentDoneDocument, options);
      }
export type SetPaymentDoneMutationHookResult = ReturnType<typeof useSetPaymentDoneMutation>;
export type SetPaymentDoneMutationResult = Apollo.MutationResult<SetPaymentDoneMutation>;
export type SetPaymentDoneMutationOptions = Apollo.BaseMutationOptions<SetPaymentDoneMutation, SetPaymentDoneMutationVariables>;
export const SendQuotationDocument = gql`
    mutation SendQuotation($docId: String!, $silent: Boolean!) {
  sendQuotation(docId: $docId, silent: $silent)
}
    `;
export type SendQuotationMutationFn = Apollo.MutationFunction<SendQuotationMutation, SendQuotationMutationVariables>;

/**
 * __useSendQuotationMutation__
 *
 * To run a mutation, you first call `useSendQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuotationMutation, { data, loading, error }] = useSendQuotationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useSendQuotationMutation(baseOptions?: Apollo.MutationHookOptions<SendQuotationMutation, SendQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendQuotationMutation, SendQuotationMutationVariables>(SendQuotationDocument, options);
      }
export type SendQuotationMutationHookResult = ReturnType<typeof useSendQuotationMutation>;
export type SendQuotationMutationResult = Apollo.MutationResult<SendQuotationMutation>;
export type SendQuotationMutationOptions = Apollo.BaseMutationOptions<SendQuotationMutation, SendQuotationMutationVariables>;
export const SendProposalDocument = gql`
    mutation SendProposal($docId: String!, $silent: Boolean!) {
  sendProposal(docId: $docId, silent: $silent)
}
    `;
export type SendProposalMutationFn = Apollo.MutationFunction<SendProposalMutation, SendProposalMutationVariables>;

/**
 * __useSendProposalMutation__
 *
 * To run a mutation, you first call `useSendProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProposalMutation, { data, loading, error }] = useSendProposalMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useSendProposalMutation(baseOptions?: Apollo.MutationHookOptions<SendProposalMutation, SendProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProposalMutation, SendProposalMutationVariables>(SendProposalDocument, options);
      }
export type SendProposalMutationHookResult = ReturnType<typeof useSendProposalMutation>;
export type SendProposalMutationResult = Apollo.MutationResult<SendProposalMutation>;
export type SendProposalMutationOptions = Apollo.BaseMutationOptions<SendProposalMutation, SendProposalMutationVariables>;
export const SendPolicyDocument = gql`
    mutation SendPolicy($docId: String!, $silent: Boolean!) {
  sendPolicy(docId: $docId, silent: $silent)
}
    `;
export type SendPolicyMutationFn = Apollo.MutationFunction<SendPolicyMutation, SendPolicyMutationVariables>;

/**
 * __useSendPolicyMutation__
 *
 * To run a mutation, you first call `useSendPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPolicyMutation, { data, loading, error }] = useSendPolicyMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useSendPolicyMutation(baseOptions?: Apollo.MutationHookOptions<SendPolicyMutation, SendPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPolicyMutation, SendPolicyMutationVariables>(SendPolicyDocument, options);
      }
export type SendPolicyMutationHookResult = ReturnType<typeof useSendPolicyMutation>;
export type SendPolicyMutationResult = Apollo.MutationResult<SendPolicyMutation>;
export type SendPolicyMutationOptions = Apollo.BaseMutationOptions<SendPolicyMutation, SendPolicyMutationVariables>;
export const ArchiveProposalDocument = gql`
    mutation archiveProposal($docId: String!) {
  archiveProposal(docId: $docId)
}
    `;
export type ArchiveProposalMutationFn = Apollo.MutationFunction<ArchiveProposalMutation, ArchiveProposalMutationVariables>;

/**
 * __useArchiveProposalMutation__
 *
 * To run a mutation, you first call `useArchiveProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProposalMutation, { data, loading, error }] = useArchiveProposalMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useArchiveProposalMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProposalMutation, ArchiveProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProposalMutation, ArchiveProposalMutationVariables>(ArchiveProposalDocument, options);
      }
export type ArchiveProposalMutationHookResult = ReturnType<typeof useArchiveProposalMutation>;
export type ArchiveProposalMutationResult = Apollo.MutationResult<ArchiveProposalMutation>;
export type ArchiveProposalMutationOptions = Apollo.BaseMutationOptions<ArchiveProposalMutation, ArchiveProposalMutationVariables>;
export const DeletePaymentDocument = gql`
    mutation DeletePayment($paymentId: String!) {
  deletePayment(paymentId: $paymentId)
}
    `;
export type DeletePaymentMutationFn = Apollo.MutationFunction<DeletePaymentMutation, DeletePaymentMutationVariables>;

/**
 * __useDeletePaymentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMutation, { data, loading, error }] = useDeletePaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useDeletePaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMutation, DeletePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMutation, DeletePaymentMutationVariables>(DeletePaymentDocument, options);
      }
export type DeletePaymentMutationHookResult = ReturnType<typeof useDeletePaymentMutation>;
export type DeletePaymentMutationResult = Apollo.MutationResult<DeletePaymentMutation>;
export type DeletePaymentMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const RecommendSimulationResultDocument = gql`
    mutation RecommendSimulationResult($docId: String!, $resultId: String!) {
  recommendSimulationResult(docId: $docId, resultId: $resultId)
}
    `;
export type RecommendSimulationResultMutationFn = Apollo.MutationFunction<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>;

/**
 * __useRecommendSimulationResultMutation__
 *
 * To run a mutation, you first call `useRecommendSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommendSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommendSimulationResultMutation, { data, loading, error }] = useRecommendSimulationResultMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useRecommendSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>(RecommendSimulationResultDocument, options);
      }
export type RecommendSimulationResultMutationHookResult = ReturnType<typeof useRecommendSimulationResultMutation>;
export type RecommendSimulationResultMutationResult = Apollo.MutationResult<RecommendSimulationResultMutation>;
export type RecommendSimulationResultMutationOptions = Apollo.BaseMutationOptions<RecommendSimulationResultMutation, RecommendSimulationResultMutationVariables>;
export const RemoveRecommendedSimulationResultDocument = gql`
    mutation RemoveRecommendedSimulationResult($docId: String!) {
  removeRecommendedSimulationResult(docId: $docId)
}
    `;
export type RemoveRecommendedSimulationResultMutationFn = Apollo.MutationFunction<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>;

/**
 * __useRemoveRecommendedSimulationResultMutation__
 *
 * To run a mutation, you first call `useRemoveRecommendedSimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRecommendedSimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRecommendedSimulationResultMutation, { data, loading, error }] = useRemoveRecommendedSimulationResultMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useRemoveRecommendedSimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>(RemoveRecommendedSimulationResultDocument, options);
      }
export type RemoveRecommendedSimulationResultMutationHookResult = ReturnType<typeof useRemoveRecommendedSimulationResultMutation>;
export type RemoveRecommendedSimulationResultMutationResult = Apollo.MutationResult<RemoveRecommendedSimulationResultMutation>;
export type RemoveRecommendedSimulationResultMutationOptions = Apollo.BaseMutationOptions<RemoveRecommendedSimulationResultMutation, RemoveRecommendedSimulationResultMutationVariables>;
export const CreateFormResponseDocument = gql`
    mutation CreateFormResponse($formId: String!, $metadata: JSON!) {
  createFormResponse(formId: $formId, metadata: $metadata) {
    _id
  }
}
    `;
export type CreateFormResponseMutationFn = Apollo.MutationFunction<CreateFormResponseMutation, CreateFormResponseMutationVariables>;

/**
 * __useCreateFormResponseMutation__
 *
 * To run a mutation, you first call `useCreateFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormResponseMutation, { data, loading, error }] = useCreateFormResponseMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormResponseMutation, CreateFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormResponseMutation, CreateFormResponseMutationVariables>(CreateFormResponseDocument, options);
      }
export type CreateFormResponseMutationHookResult = ReturnType<typeof useCreateFormResponseMutation>;
export type CreateFormResponseMutationResult = Apollo.MutationResult<CreateFormResponseMutation>;
export type CreateFormResponseMutationOptions = Apollo.BaseMutationOptions<CreateFormResponseMutation, CreateFormResponseMutationVariables>;
export const UpsertFormFieldDocument = gql`
    mutation UpsertFormField($formResponseId: String!, $fieldPath: String!, $value: JSON!) {
  upsertFormField(
    formResponseId: $formResponseId
    fieldPath: $fieldPath
    value: $value
  )
}
    `;
export type UpsertFormFieldMutationFn = Apollo.MutationFunction<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>;

/**
 * __useUpsertFormFieldMutation__
 *
 * To run a mutation, you first call `useUpsertFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFormFieldMutation, { data, loading, error }] = useUpsertFormFieldMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *      fieldPath: // value for 'fieldPath'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertFormFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>(UpsertFormFieldDocument, options);
      }
export type UpsertFormFieldMutationHookResult = ReturnType<typeof useUpsertFormFieldMutation>;
export type UpsertFormFieldMutationResult = Apollo.MutationResult<UpsertFormFieldMutation>;
export type UpsertFormFieldMutationOptions = Apollo.BaseMutationOptions<UpsertFormFieldMutation, UpsertFormFieldMutationVariables>;
export const SubmitFormResponseDocument = gql`
    mutation SubmitFormResponse($formResponseId: String!) {
  submitFormResponse(formResponseId: $formResponseId)
}
    `;
export type SubmitFormResponseMutationFn = Apollo.MutationFunction<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>;

/**
 * __useSubmitFormResponseMutation__
 *
 * To run a mutation, you first call `useSubmitFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResponseMutation, { data, loading, error }] = useSubmitFormResponseMutation({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useSubmitFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>(SubmitFormResponseDocument, options);
      }
export type SubmitFormResponseMutationHookResult = ReturnType<typeof useSubmitFormResponseMutation>;
export type SubmitFormResponseMutationResult = Apollo.MutationResult<SubmitFormResponseMutation>;
export type SubmitFormResponseMutationOptions = Apollo.BaseMutationOptions<SubmitFormResponseMutation, SubmitFormResponseMutationVariables>;
export const SendTransactionalEventDocument = gql`
    mutation SendTransactionalEvent($docId: String!, $event: TransactionalEvents!) {
  sendTransactionalEvent(docId: $docId, event: $event)
}
    `;
export type SendTransactionalEventMutationFn = Apollo.MutationFunction<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>;

/**
 * __useSendTransactionalEventMutation__
 *
 * To run a mutation, you first call `useSendTransactionalEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTransactionalEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTransactionalEventMutation, { data, loading, error }] = useSendTransactionalEventMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useSendTransactionalEventMutation(baseOptions?: Apollo.MutationHookOptions<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>(SendTransactionalEventDocument, options);
      }
export type SendTransactionalEventMutationHookResult = ReturnType<typeof useSendTransactionalEventMutation>;
export type SendTransactionalEventMutationResult = Apollo.MutationResult<SendTransactionalEventMutation>;
export type SendTransactionalEventMutationOptions = Apollo.BaseMutationOptions<SendTransactionalEventMutation, SendTransactionalEventMutationVariables>;
export const AddCommercialResponsibleLeadDocument = gql`
    mutation addCommercialResponsibleLead($leadId: String!, $responsibleId: String!) {
  addCommercialResponsibleToLead(leadId: $leadId, responsibleId: $responsibleId)
}
    `;
export type AddCommercialResponsibleLeadMutationFn = Apollo.MutationFunction<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>;

/**
 * __useAddCommercialResponsibleLeadMutation__
 *
 * To run a mutation, you first call `useAddCommercialResponsibleLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommercialResponsibleLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommercialResponsibleLeadMutation, { data, loading, error }] = useAddCommercialResponsibleLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddCommercialResponsibleLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>(AddCommercialResponsibleLeadDocument, options);
      }
export type AddCommercialResponsibleLeadMutationHookResult = ReturnType<typeof useAddCommercialResponsibleLeadMutation>;
export type AddCommercialResponsibleLeadMutationResult = Apollo.MutationResult<AddCommercialResponsibleLeadMutation>;
export type AddCommercialResponsibleLeadMutationOptions = Apollo.BaseMutationOptions<AddCommercialResponsibleLeadMutation, AddCommercialResponsibleLeadMutationVariables>;
export const AddTechnicalResponsibleLeadDocument = gql`
    mutation addTechnicalResponsibleLead($leadId: String!, $responsibleId: String!) {
  addTechnicalResponsibleToLead(leadId: $leadId, responsibleId: $responsibleId)
}
    `;
export type AddTechnicalResponsibleLeadMutationFn = Apollo.MutationFunction<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>;

/**
 * __useAddTechnicalResponsibleLeadMutation__
 *
 * To run a mutation, you first call `useAddTechnicalResponsibleLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTechnicalResponsibleLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTechnicalResponsibleLeadMutation, { data, loading, error }] = useAddTechnicalResponsibleLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddTechnicalResponsibleLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>(AddTechnicalResponsibleLeadDocument, options);
      }
export type AddTechnicalResponsibleLeadMutationHookResult = ReturnType<typeof useAddTechnicalResponsibleLeadMutation>;
export type AddTechnicalResponsibleLeadMutationResult = Apollo.MutationResult<AddTechnicalResponsibleLeadMutation>;
export type AddTechnicalResponsibleLeadMutationOptions = Apollo.BaseMutationOptions<AddTechnicalResponsibleLeadMutation, AddTechnicalResponsibleLeadMutationVariables>;
export const ChangeLeadStatusDocument = gql`
    mutation changeLeadStatus($leadId: String!, $status: LeadStatus!) {
  changeLeadStatus(leadId: $leadId, status: $status)
}
    `;
export type ChangeLeadStatusMutationFn = Apollo.MutationFunction<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;

/**
 * __useChangeLeadStatusMutation__
 *
 * To run a mutation, you first call `useChangeLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLeadStatusMutation, { data, loading, error }] = useChangeLeadStatusMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>(ChangeLeadStatusDocument, options);
      }
export type ChangeLeadStatusMutationHookResult = ReturnType<typeof useChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationResult = Apollo.MutationResult<ChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationOptions = Apollo.BaseMutationOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;
export const RateLeadDocument = gql`
    mutation rateLead($leadId: String!, $rating: RatingScale!) {
  rateLead(leadId: $leadId, rating: $rating)
}
    `;
export type RateLeadMutationFn = Apollo.MutationFunction<RateLeadMutation, RateLeadMutationVariables>;

/**
 * __useRateLeadMutation__
 *
 * To run a mutation, you first call `useRateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateLeadMutation, { data, loading, error }] = useRateLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useRateLeadMutation(baseOptions?: Apollo.MutationHookOptions<RateLeadMutation, RateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateLeadMutation, RateLeadMutationVariables>(RateLeadDocument, options);
      }
export type RateLeadMutationHookResult = ReturnType<typeof useRateLeadMutation>;
export type RateLeadMutationResult = Apollo.MutationResult<RateLeadMutation>;
export type RateLeadMutationOptions = Apollo.BaseMutationOptions<RateLeadMutation, RateLeadMutationVariables>;
export const AddCommentToLeadDocument = gql`
    mutation addCommentToLead($leadId: String!, $comment: String!) {
  addCommentToLead(leadId: $leadId, comment: $comment)
}
    `;
export type AddCommentToLeadMutationFn = Apollo.MutationFunction<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>;

/**
 * __useAddCommentToLeadMutation__
 *
 * To run a mutation, you first call `useAddCommentToLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentToLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentToLeadMutation, { data, loading, error }] = useAddCommentToLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentToLeadMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>(AddCommentToLeadDocument, options);
      }
export type AddCommentToLeadMutationHookResult = ReturnType<typeof useAddCommentToLeadMutation>;
export type AddCommentToLeadMutationResult = Apollo.MutationResult<AddCommentToLeadMutation>;
export type AddCommentToLeadMutationOptions = Apollo.BaseMutationOptions<AddCommentToLeadMutation, AddCommentToLeadMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($docId: String!, $authorId: String!, $serviceName: Services!, $text: String!) {
  createNote(
    docId: $docId
    authorId: $authorId
    serviceName: $serviceName
    text: $text
  )
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      authorId: // value for 'authorId'
 *      serviceName: // value for 'serviceName'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const RetrySimulationResultDocument = gql`
    mutation RetrySimulationResult($resultId: String!) {
  retrySimulationResult(resultId: $resultId)
}
    `;
export type RetrySimulationResultMutationFn = Apollo.MutationFunction<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>;

/**
 * __useRetrySimulationResultMutation__
 *
 * To run a mutation, you first call `useRetrySimulationResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySimulationResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySimulationResultMutation, { data, loading, error }] = useRetrySimulationResultMutation({
 *   variables: {
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useRetrySimulationResultMutation(baseOptions?: Apollo.MutationHookOptions<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>(RetrySimulationResultDocument, options);
      }
export type RetrySimulationResultMutationHookResult = ReturnType<typeof useRetrySimulationResultMutation>;
export type RetrySimulationResultMutationResult = Apollo.MutationResult<RetrySimulationResultMutation>;
export type RetrySimulationResultMutationOptions = Apollo.BaseMutationOptions<RetrySimulationResultMutation, RetrySimulationResultMutationVariables>;
export const SendTwilioWaMessageDocument = gql`
    mutation SendTwilioWAMessage($contactId: String!, $content: String!, $files: [TwilioMediaInput!]!) {
  sendTwilioWAMessage(contactId: $contactId, content: $content, files: $files)
}
    `;
export type SendTwilioWaMessageMutationFn = Apollo.MutationFunction<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>;

/**
 * __useSendTwilioWaMessageMutation__
 *
 * To run a mutation, you first call `useSendTwilioWaMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTwilioWaMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTwilioWaMessageMutation, { data, loading, error }] = useSendTwilioWaMessageMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      content: // value for 'content'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSendTwilioWaMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>(SendTwilioWaMessageDocument, options);
      }
export type SendTwilioWaMessageMutationHookResult = ReturnType<typeof useSendTwilioWaMessageMutation>;
export type SendTwilioWaMessageMutationResult = Apollo.MutationResult<SendTwilioWaMessageMutation>;
export type SendTwilioWaMessageMutationOptions = Apollo.BaseMutationOptions<SendTwilioWaMessageMutation, SendTwilioWaMessageMutationVariables>;
export const AddResponsibleToUserDocument = gql`
    mutation AddResponsibleToUser($userId: String!, $responsibleId: String!) {
  addResponsibleToUser(userId: $userId, responsibleId: $responsibleId)
}
    `;
export type AddResponsibleToUserMutationFn = Apollo.MutationFunction<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>;

/**
 * __useAddResponsibleToUserMutation__
 *
 * To run a mutation, you first call `useAddResponsibleToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResponsibleToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResponsibleToUserMutation, { data, loading, error }] = useAddResponsibleToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      responsibleId: // value for 'responsibleId'
 *   },
 * });
 */
export function useAddResponsibleToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>(AddResponsibleToUserDocument, options);
      }
export type AddResponsibleToUserMutationHookResult = ReturnType<typeof useAddResponsibleToUserMutation>;
export type AddResponsibleToUserMutationResult = Apollo.MutationResult<AddResponsibleToUserMutation>;
export type AddResponsibleToUserMutationOptions = Apollo.BaseMutationOptions<AddResponsibleToUserMutation, AddResponsibleToUserMutationVariables>;
export const AddRatingToUserDocument = gql`
    mutation AddRatingToUser($userId: String!, $rating: RatingScale!) {
  addRatingToUser(userId: $userId, rating: $rating)
}
    `;
export type AddRatingToUserMutationFn = Apollo.MutationFunction<AddRatingToUserMutation, AddRatingToUserMutationVariables>;

/**
 * __useAddRatingToUserMutation__
 *
 * To run a mutation, you first call `useAddRatingToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRatingToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRatingToUserMutation, { data, loading, error }] = useAddRatingToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useAddRatingToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddRatingToUserMutation, AddRatingToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRatingToUserMutation, AddRatingToUserMutationVariables>(AddRatingToUserDocument, options);
      }
export type AddRatingToUserMutationHookResult = ReturnType<typeof useAddRatingToUserMutation>;
export type AddRatingToUserMutationResult = Apollo.MutationResult<AddRatingToUserMutation>;
export type AddRatingToUserMutationOptions = Apollo.BaseMutationOptions<AddRatingToUserMutation, AddRatingToUserMutationVariables>;
export const AddCommentToUserDocument = gql`
    mutation AddCommentToUser($userId: String!, $comment: String!) {
  addCommentToUser(userId: $userId, comment: $comment)
}
    `;
export type AddCommentToUserMutationFn = Apollo.MutationFunction<AddCommentToUserMutation, AddCommentToUserMutationVariables>;

/**
 * __useAddCommentToUserMutation__
 *
 * To run a mutation, you first call `useAddCommentToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentToUserMutation, { data, loading, error }] = useAddCommentToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentToUserMutation, AddCommentToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentToUserMutation, AddCommentToUserMutationVariables>(AddCommentToUserDocument, options);
      }
export type AddCommentToUserMutationHookResult = ReturnType<typeof useAddCommentToUserMutation>;
export type AddCommentToUserMutationResult = Apollo.MutationResult<AddCommentToUserMutation>;
export type AddCommentToUserMutationOptions = Apollo.BaseMutationOptions<AddCommentToUserMutation, AddCommentToUserMutationVariables>;
export const AddCultureToUserDocument = gql`
    mutation AddCultureToUser($userId: String!, $cultureIds: [ObjectId!]) {
  addCultureToUser(userId: $userId, cultureIds: $cultureIds)
}
    `;
export type AddCultureToUserMutationFn = Apollo.MutationFunction<AddCultureToUserMutation, AddCultureToUserMutationVariables>;

/**
 * __useAddCultureToUserMutation__
 *
 * To run a mutation, you first call `useAddCultureToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCultureToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCultureToUserMutation, { data, loading, error }] = useAddCultureToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      cultureIds: // value for 'cultureIds'
 *   },
 * });
 */
export function useAddCultureToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddCultureToUserMutation, AddCultureToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCultureToUserMutation, AddCultureToUserMutationVariables>(AddCultureToUserDocument, options);
      }
export type AddCultureToUserMutationHookResult = ReturnType<typeof useAddCultureToUserMutation>;
export type AddCultureToUserMutationResult = Apollo.MutationResult<AddCultureToUserMutation>;
export type AddCultureToUserMutationOptions = Apollo.BaseMutationOptions<AddCultureToUserMutation, AddCultureToUserMutationVariables>;
export const AddCourseToUserDocument = gql`
    mutation AddCourseToUser($userId: String!, $finishedCourse: Boolean!) {
  addCourseToUser(userId: $userId, finishedCourse: $finishedCourse)
}
    `;
export type AddCourseToUserMutationFn = Apollo.MutationFunction<AddCourseToUserMutation, AddCourseToUserMutationVariables>;

/**
 * __useAddCourseToUserMutation__
 *
 * To run a mutation, you first call `useAddCourseToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCourseToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCourseToUserMutation, { data, loading, error }] = useAddCourseToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      finishedCourse: // value for 'finishedCourse'
 *   },
 * });
 */
export function useAddCourseToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddCourseToUserMutation, AddCourseToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCourseToUserMutation, AddCourseToUserMutationVariables>(AddCourseToUserDocument, options);
      }
export type AddCourseToUserMutationHookResult = ReturnType<typeof useAddCourseToUserMutation>;
export type AddCourseToUserMutationResult = Apollo.MutationResult<AddCourseToUserMutation>;
export type AddCourseToUserMutationOptions = Apollo.BaseMutationOptions<AddCourseToUserMutation, AddCourseToUserMutationVariables>;
export const GetCreateClaimOnFormResponseDocument = gql`
    query GetCreateClaimOnFormResponse($documentId: String!) {
  getCreateClaimOnFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateClaimOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateClaimOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateClaimOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateClaimOnFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateClaimOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>(GetCreateClaimOnFormResponseDocument, options);
      }
export function useGetCreateClaimOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>(GetCreateClaimOnFormResponseDocument, options);
        }
export type GetCreateClaimOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateClaimOnFormResponseQuery>;
export type GetCreateClaimOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateClaimOnFormResponseLazyQuery>;
export type GetCreateClaimOnFormResponseQueryResult = Apollo.QueryResult<GetCreateClaimOnFormResponseQuery, GetCreateClaimOnFormResponseQueryVariables>;
export const GetEditClaimOnFormResponseDocument = gql`
    query GetEditClaimOnFormResponse($objectId: String!) {
  getEditClaimOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditClaimOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditClaimOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditClaimOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditClaimOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditClaimOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>(GetEditClaimOnFormResponseDocument, options);
      }
export function useGetEditClaimOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>(GetEditClaimOnFormResponseDocument, options);
        }
export type GetEditClaimOnFormResponseQueryHookResult = ReturnType<typeof useGetEditClaimOnFormResponseQuery>;
export type GetEditClaimOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditClaimOnFormResponseLazyQuery>;
export type GetEditClaimOnFormResponseQueryResult = Apollo.QueryResult<GetEditClaimOnFormResponseQuery, GetEditClaimOnFormResponseQueryVariables>;
export const GetEditConclusionLetterOnClaimDocument = gql`
    query GetEditConclusionLetterOnClaim($objectId: String!) {
  getEditConclusionLetterOnClaim(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditConclusionLetterOnClaimQuery__
 *
 * To run a query within a React component, call `useGetEditConclusionLetterOnClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditConclusionLetterOnClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditConclusionLetterOnClaimQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditConclusionLetterOnClaimQuery(baseOptions: Apollo.QueryHookOptions<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>(GetEditConclusionLetterOnClaimDocument, options);
      }
export function useGetEditConclusionLetterOnClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>(GetEditConclusionLetterOnClaimDocument, options);
        }
export type GetEditConclusionLetterOnClaimQueryHookResult = ReturnType<typeof useGetEditConclusionLetterOnClaimQuery>;
export type GetEditConclusionLetterOnClaimLazyQueryHookResult = ReturnType<typeof useGetEditConclusionLetterOnClaimLazyQuery>;
export type GetEditConclusionLetterOnClaimQueryResult = Apollo.QueryResult<GetEditConclusionLetterOnClaimQuery, GetEditConclusionLetterOnClaimQueryVariables>;
export const GetEditEstimatedIndemnityOnClaimDocument = gql`
    query GetEditEstimatedIndemnityOnClaim($objectId: String!) {
  getEditEstimatedIndemnityOnClaim(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditEstimatedIndemnityOnClaimQuery__
 *
 * To run a query within a React component, call `useGetEditEstimatedIndemnityOnClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditEstimatedIndemnityOnClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditEstimatedIndemnityOnClaimQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditEstimatedIndemnityOnClaimQuery(baseOptions: Apollo.QueryHookOptions<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>(GetEditEstimatedIndemnityOnClaimDocument, options);
      }
export function useGetEditEstimatedIndemnityOnClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>(GetEditEstimatedIndemnityOnClaimDocument, options);
        }
export type GetEditEstimatedIndemnityOnClaimQueryHookResult = ReturnType<typeof useGetEditEstimatedIndemnityOnClaimQuery>;
export type GetEditEstimatedIndemnityOnClaimLazyQueryHookResult = ReturnType<typeof useGetEditEstimatedIndemnityOnClaimLazyQuery>;
export type GetEditEstimatedIndemnityOnClaimQueryResult = Apollo.QueryResult<GetEditEstimatedIndemnityOnClaimQuery, GetEditEstimatedIndemnityOnClaimQueryVariables>;
export const GetEditContestationLetterOnClaimDocument = gql`
    query GetEditContestationLetterOnClaim($objectId: String!) {
  getEditContestationLetterOnClaim(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditContestationLetterOnClaimQuery__
 *
 * To run a query within a React component, call `useGetEditContestationLetterOnClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditContestationLetterOnClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditContestationLetterOnClaimQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditContestationLetterOnClaimQuery(baseOptions: Apollo.QueryHookOptions<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>(GetEditContestationLetterOnClaimDocument, options);
      }
export function useGetEditContestationLetterOnClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>(GetEditContestationLetterOnClaimDocument, options);
        }
export type GetEditContestationLetterOnClaimQueryHookResult = ReturnType<typeof useGetEditContestationLetterOnClaimQuery>;
export type GetEditContestationLetterOnClaimLazyQueryHookResult = ReturnType<typeof useGetEditContestationLetterOnClaimLazyQuery>;
export type GetEditContestationLetterOnClaimQueryResult = Apollo.QueryResult<GetEditContestationLetterOnClaimQuery, GetEditContestationLetterOnClaimQueryVariables>;
export const GetEditFarmerOnDocumentFormResponseDocument = gql`
    query GetEditFarmerOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditFarmerOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditFarmerOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditFarmerOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditFarmerOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditFarmerOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditFarmerOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>(GetEditFarmerOnDocumentFormResponseDocument, options);
      }
export function useGetEditFarmerOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>(GetEditFarmerOnDocumentFormResponseDocument, options);
        }
export type GetEditFarmerOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditFarmerOnDocumentFormResponseQuery>;
export type GetEditFarmerOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditFarmerOnDocumentFormResponseLazyQuery>;
export type GetEditFarmerOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditFarmerOnDocumentFormResponseQuery, GetEditFarmerOnDocumentFormResponseQueryVariables>;
export const GetEditFinancialResponsibleOnDocumentFormResponseDocument = gql`
    query getEditFinancialResponsibleOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditFinancialResponsibleOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditFinancialResponsibleOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditFinancialResponsibleOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditFinancialResponsibleOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditFinancialResponsibleOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditFinancialResponsibleOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>(GetEditFinancialResponsibleOnDocumentFormResponseDocument, options);
      }
export function useGetEditFinancialResponsibleOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>(GetEditFinancialResponsibleOnDocumentFormResponseDocument, options);
        }
export type GetEditFinancialResponsibleOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditFinancialResponsibleOnDocumentFormResponseQuery>;
export type GetEditFinancialResponsibleOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditFinancialResponsibleOnDocumentFormResponseLazyQuery>;
export type GetEditFinancialResponsibleOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditFinancialResponsibleOnDocumentFormResponseQuery, GetEditFinancialResponsibleOnDocumentFormResponseQueryVariables>;
export const GetEditCropOnDocumentFormResponseDocument = gql`
    query GetEditCropOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditCropOnDocumentFormResponse(objectId: $objectId, documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditCropOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditCropOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditCropOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditCropOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditCropOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>(GetEditCropOnDocumentFormResponseDocument, options);
      }
export function useGetEditCropOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>(GetEditCropOnDocumentFormResponseDocument, options);
        }
export type GetEditCropOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditCropOnDocumentFormResponseQuery>;
export type GetEditCropOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditCropOnDocumentFormResponseLazyQuery>;
export type GetEditCropOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditCropOnDocumentFormResponseQuery, GetEditCropOnDocumentFormResponseQueryVariables>;
export const ListDocumentsDocument = gql`
    query listDocuments($filter: [[DocumentsFilterInput]]!) {
  documents(filter: $filter) {
    _id
    stage
    status
    createdAt
    commercialResponsibleId
    commercialResponsible {
      nome
    }
    operationalResponsibleId
    operationalResponsible {
      nome
    }
    originatorId
    originator {
      nome
    }
    farmer {
      name
    }
    crop {
      cultureName
      culture {
        name
      }
      area
    }
    property {
      address {
        city
        state
      }
    }
    insuranceTypeGroup
  }
}
    `;

/**
 * __useListDocumentsQuery__
 *
 * To run a query within a React component, call `useListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
      }
export function useListDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
        }
export type ListDocumentsQueryHookResult = ReturnType<typeof useListDocumentsQuery>;
export type ListDocumentsLazyQueryHookResult = ReturnType<typeof useListDocumentsLazyQuery>;
export type ListDocumentsQueryResult = Apollo.QueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export const CountDocumentsDocument = gql`
    query CountDocuments($filter: [[DocumentsFilterInput]]!) {
  countDocuments(filter: $filter)
}
    `;

/**
 * __useCountDocumentsQuery__
 *
 * To run a query within a React component, call `useCountDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountDocumentsQuery(baseOptions: Apollo.QueryHookOptions<CountDocumentsQuery, CountDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountDocumentsQuery, CountDocumentsQueryVariables>(CountDocumentsDocument, options);
      }
export function useCountDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountDocumentsQuery, CountDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountDocumentsQuery, CountDocumentsQueryVariables>(CountDocumentsDocument, options);
        }
export type CountDocumentsQueryHookResult = ReturnType<typeof useCountDocumentsQuery>;
export type CountDocumentsLazyQueryHookResult = ReturnType<typeof useCountDocumentsLazyQuery>;
export type CountDocumentsQueryResult = Apollo.QueryResult<CountDocumentsQuery, CountDocumentsQueryVariables>;
export const GetComplementaryDataFormResponseDocument = gql`
    query GetComplementaryDataFormResponse($objectId: String!) {
  getComplementaryDataFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetComplementaryDataFormResponseQuery__
 *
 * To run a query within a React component, call `useGetComplementaryDataFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplementaryDataFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplementaryDataFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetComplementaryDataFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>(GetComplementaryDataFormResponseDocument, options);
      }
export function useGetComplementaryDataFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>(GetComplementaryDataFormResponseDocument, options);
        }
export type GetComplementaryDataFormResponseQueryHookResult = ReturnType<typeof useGetComplementaryDataFormResponseQuery>;
export type GetComplementaryDataFormResponseLazyQueryHookResult = ReturnType<typeof useGetComplementaryDataFormResponseLazyQuery>;
export type GetComplementaryDataFormResponseQueryResult = Apollo.QueryResult<GetComplementaryDataFormResponseQuery, GetComplementaryDataFormResponseQueryVariables>;
export const GetNfeUploadFormResponseDocument = gql`
    query GetNfeUploadFormResponse($objectId: String!) {
  getNfeUploadFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetNfeUploadFormResponseQuery__
 *
 * To run a query within a React component, call `useGetNfeUploadFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNfeUploadFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNfeUploadFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetNfeUploadFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>(GetNfeUploadFormResponseDocument, options);
      }
export function useGetNfeUploadFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>(GetNfeUploadFormResponseDocument, options);
        }
export type GetNfeUploadFormResponseQueryHookResult = ReturnType<typeof useGetNfeUploadFormResponseQuery>;
export type GetNfeUploadFormResponseLazyQueryHookResult = ReturnType<typeof useGetNfeUploadFormResponseLazyQuery>;
export type GetNfeUploadFormResponseQueryResult = Apollo.QueryResult<GetNfeUploadFormResponseQuery, GetNfeUploadFormResponseQueryVariables>;
export const GetEditPaymentDataOnDocumentFormResponseDocument = gql`
    query getEditPaymentDataOnDocumentFormResponse($objectId: String!) {
  getEditPaymentDataOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPaymentDataOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPaymentDataOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPaymentDataOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPaymentDataOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPaymentDataOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>(GetEditPaymentDataOnDocumentFormResponseDocument, options);
      }
export function useGetEditPaymentDataOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>(GetEditPaymentDataOnDocumentFormResponseDocument, options);
        }
export type GetEditPaymentDataOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPaymentDataOnDocumentFormResponseQuery>;
export type GetEditPaymentDataOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPaymentDataOnDocumentFormResponseLazyQuery>;
export type GetEditPaymentDataOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPaymentDataOnDocumentFormResponseQuery, GetEditPaymentDataOnDocumentFormResponseQueryVariables>;
export const GetDocumentRejectionFormResponseDocument = gql`
    query GetDocumentRejectionFormResponse($documentId: String!) {
  getDocumentRejectionFormResponse(documentId: $documentId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetDocumentRejectionFormResponseQuery__
 *
 * To run a query within a React component, call `useGetDocumentRejectionFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentRejectionFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentRejectionFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentRejectionFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>(GetDocumentRejectionFormResponseDocument, options);
      }
export function useGetDocumentRejectionFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>(GetDocumentRejectionFormResponseDocument, options);
        }
export type GetDocumentRejectionFormResponseQueryHookResult = ReturnType<typeof useGetDocumentRejectionFormResponseQuery>;
export type GetDocumentRejectionFormResponseLazyQueryHookResult = ReturnType<typeof useGetDocumentRejectionFormResponseLazyQuery>;
export type GetDocumentRejectionFormResponseQueryResult = Apollo.QueryResult<GetDocumentRejectionFormResponseQuery, GetDocumentRejectionFormResponseQueryVariables>;
export const GetDocumentsDashboardCountersDocument = gql`
    query GetDocumentsDashboardCounters($filter: DocumentsFilterInput) {
  getDocumentsDashboardCounters(filter: $filter) {
    count
    value
    statuses {
      count
      value
    }
  }
}
    `;

/**
 * __useGetDocumentsDashboardCountersQuery__
 *
 * To run a query within a React component, call `useGetDocumentsDashboardCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsDashboardCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsDashboardCountersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDocumentsDashboardCountersQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>(GetDocumentsDashboardCountersDocument, options);
      }
export function useGetDocumentsDashboardCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>(GetDocumentsDashboardCountersDocument, options);
        }
export type GetDocumentsDashboardCountersQueryHookResult = ReturnType<typeof useGetDocumentsDashboardCountersQuery>;
export type GetDocumentsDashboardCountersLazyQueryHookResult = ReturnType<typeof useGetDocumentsDashboardCountersLazyQuery>;
export type GetDocumentsDashboardCountersQueryResult = Apollo.QueryResult<GetDocumentsDashboardCountersQuery, GetDocumentsDashboardCountersQueryVariables>;
export const GetDocumentsDashboardTotalValuesDocument = gql`
    query GetDocumentsDashboardTotalValues($input: DashboardTotalValueDateRange!) {
  getDocumentsDashboardTotalValues(input: $input) {
    category
    value
  }
}
    `;

/**
 * __useGetDocumentsDashboardTotalValuesQuery__
 *
 * To run a query within a React component, call `useGetDocumentsDashboardTotalValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsDashboardTotalValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsDashboardTotalValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentsDashboardTotalValuesQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsDashboardTotalValuesQuery, GetDocumentsDashboardTotalValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsDashboardTotalValuesQuery, GetDocumentsDashboardTotalValuesQueryVariables>(GetDocumentsDashboardTotalValuesDocument, options);
      }
export function useGetDocumentsDashboardTotalValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsDashboardTotalValuesQuery, GetDocumentsDashboardTotalValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsDashboardTotalValuesQuery, GetDocumentsDashboardTotalValuesQueryVariables>(GetDocumentsDashboardTotalValuesDocument, options);
        }
export type GetDocumentsDashboardTotalValuesQueryHookResult = ReturnType<typeof useGetDocumentsDashboardTotalValuesQuery>;
export type GetDocumentsDashboardTotalValuesLazyQueryHookResult = ReturnType<typeof useGetDocumentsDashboardTotalValuesLazyQuery>;
export type GetDocumentsDashboardTotalValuesQueryResult = Apollo.QueryResult<GetDocumentsDashboardTotalValuesQuery, GetDocumentsDashboardTotalValuesQueryVariables>;
export const GetDocumentDetailsDocument = gql`
    query GetDocumentDetails($docId: String!) {
  document(docId: $docId) {
    _id
    createdAt
    updatedAt
    stage
    status
    provider
    rejectReason {
      other
      rejectReason
    }
    selectedResultIds
    recommendedSimulationResultId
    justificationMessage
    insuranceTypeGroup
    commercialResponsibleId
    operationalResponsibleId
    claimResponsibleId
    originatorId
    premium
    archived
    proposalResultId
    visitPerson {
      name
    }
    costNFFiles {
      fileName
      fileKey
    }
    kmlFile {
      fileName
      fileKey
    }
    crop {
      _id
      area
      cultureName
      harvestStartDate
      harvestEndDate
      culture {
        name
      }
      cultureDetail {
        name
      }
      manualCulture
      kmlFile {
        fileName
        fileKey
      }
      compositionType
      cropYear
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
        seedType
      }
    }
    farmer {
      _id
      name
      cpfCnpj
      mobilePhone
      email
      rg
      emissionInstitution
      expeditionDate
      civilState
      gender
      birthDate
      profession
      documentFile {
        fileName
        fileKey
      }
      addressProofFile {
        fileName
        fileKey
      }
      address {
        city
        state
        street
        number
        complement
        cep
      }
    }
    property {
      _id
      accessInstructions
      address {
        city
        state
        street
        number
        complement
        cep
      }
      entranceLocation
      name
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
      }
    }
    failedSimulationResults {
      _id
      error
      provider
    }
    validSimulationResults {
      _id
      status
      provider
      basicCoverageType
      guaranteedProductivity
      sackValue
      tags
      coverages {
        name
        lmi
        premium
        coverageEvents {
          _id
          name
        }
      }
      referenceLocation
      amounts {
        lmi
        totalPremium
        stateSubvention
        federalSubvention
        finalPremium
        maxPayments
      }
    }
    simulationResults {
      _id
      externalId
      status
      error
      name
      provider
      basicCoverageType
      guaranteedProductivity
      sackValue
      coverages {
        name
        lmi
        premium
        coverageEvents {
          _id
          name
        }
      }
      referenceLocation
      amounts {
        lmi
        totalPremium
        stateSubvention
        federalSubvention
        finalPremium
        maxPayments
      }
    }
    selectedSimulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      sackValue
      tags
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      referenceLocation
      coverages {
        name
        lmi
        premium
        coverageEvents {
          _id
          name
        }
      }
    }
    proposalResult {
      _id
      externalId
      name
      provider
      basicCoverageType
      guaranteedProductivity
      proposalFile {
        fileName
        fileKey
      }
      signedProposalFile {
        _id
        fileName
        fileKey
      }
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      coverages {
        name
        lmi
        premium
        coverageTags
      }
    }
    beneficiary {
      _id
      name
      cpfCnpj
      mobilePhone
      email
      rg
      emissionInstitution
      expeditionDate
      civilState
      gender
      birthDate
      profession
      documentFile {
        fileName
        fileKey
      }
      addressProofFile {
        fileName
        fileKey
      }
      address {
        city
        state
        street
        number
        complement
        cep
      }
    }
    allowedVisitPeople {
      name
      cpfCnpj
      mobilePhone
      email
    }
    policy {
      _id
      endDate
      startDate
      externalId
      billsFile {
        fileName
        fileKey
      }
      policyFile {
        fileName
        fileKey
      }
      cancellationReason
    }
    paymentData {
      method
      responsibleId
      installments
      accountData {
        bank
        agency
        account
      }
      responsible {
        _id
        name
        cpfCnpj
        mobilePhone
        email
        rg
        emissionInstitution
        expeditionDate
        civilState
        gender
        birthDate
        profession
        documentFile {
          fileName
          fileKey
        }
        addressProofFile {
          fileName
          fileKey
        }
        address {
          city
          state
          street
          number
          complement
          cep
        }
      }
    }
    payments {
      _id
      responsibleId
      provider
      name
      dateDue
      amount
      billFile {
        fileName
        fileKey
      }
      status
      subventionType
    }
    archivedProposals {
      _id
      externalId
      provider
      basicCoverageType
      type
      insuranceTypeGroup
      guaranteedProductivity
    }
    claims {
      _id
      name
      externalId
      status
      events
      plots
      coverages
      startDate
      endDate
      lossEstimate
      comment
      createdAt
      protocolNumber
      noticeDate
      indemnityAmount
      indemnityPaymentDate
      reportFile {
        fileName
        fileKey
      }
      indemnityAmount
      indemnityPaymentDate
      estimatedIndemnity
      contestationLetterFile {
        fileName
        fileKey
      }
      contestationProtocolNumber
      dateOfReanalysis
    }
    inspections {
      _id
      documentId
      status
      type
      date
      regulatoryAgency
      claims {
        name
      }
      inspector {
        name
        mobilePhone
      }
      reportFile {
        fileName
        fileKey
      }
    }
  }
}
    `;

/**
 * __useGetDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useGetDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
      }
export function useGetDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
export type GetDocumentDetailsQueryHookResult = ReturnType<typeof useGetDocumentDetailsQuery>;
export type GetDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsLazyQuery>;
export type GetDocumentDetailsQueryResult = Apollo.QueryResult<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>;
export const GetDirectDocumentDetailsDocument = gql`
    query GetDirectDocumentDetails($docId: String!) {
  document(docId: $docId) {
    _id
    stage
    status
    justificationMessage
    recommendedSimulationResultId
    insuranceTypeGroup
    premium
    createdAt
    crop {
      area
      cultureName
      culture {
        name
      }
      cultureDetail {
        name
      }
      manualCulture
    }
    farmer {
      name
      cpfCnpj
    }
    property {
      name
      plots {
        name
        cultureDetail {
          name
        }
        area
        plantDate
        plantMethod
        soilType
        irrigated
        cropYear
        plantSpacing
        lineSpacing
      }
      address {
        city
        state
      }
    }
    specialOperationId
    selectedSimulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      sackValue
      tags
      referenceLocation
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      coverages {
        name
        lmi
        premium
        coverageEvents {
          _id
          name
        }
      }
    }
    simulationResults {
      _id
      name
      provider
      status
      basicCoverageType
      guaranteedProductivity
      referenceLocation
      amounts {
        lmi
        totalPremium
        maxPayments
        stateSubvention
        federalSubvention
        finalPremium
      }
      coverages {
        name
        lmi
        premium
        coverageEvents {
          _id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetDirectDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDirectDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useGetDirectDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>(GetDirectDocumentDetailsDocument, options);
      }
export function useGetDirectDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>(GetDirectDocumentDetailsDocument, options);
        }
export type GetDirectDocumentDetailsQueryHookResult = ReturnType<typeof useGetDirectDocumentDetailsQuery>;
export type GetDirectDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDirectDocumentDetailsLazyQuery>;
export type GetDirectDocumentDetailsQueryResult = Apollo.QueryResult<GetDirectDocumentDetailsQuery, GetDirectDocumentDetailsQueryVariables>;
export const GetFormResponseDocument = gql`
    query GetFormResponse($formResponseId: String!) {
  getFormResponse(formResponseId: $formResponseId) {
    formData
    formState
    errors
  }
}
    `;

/**
 * __useGetFormResponseQuery__
 *
 * To run a query within a React component, call `useGetFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponseQuery({
 *   variables: {
 *      formResponseId: // value for 'formResponseId'
 *   },
 * });
 */
export function useGetFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetFormResponseQuery, GetFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormResponseQuery, GetFormResponseQueryVariables>(GetFormResponseDocument, options);
      }
export function useGetFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormResponseQuery, GetFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormResponseQuery, GetFormResponseQueryVariables>(GetFormResponseDocument, options);
        }
export type GetFormResponseQueryHookResult = ReturnType<typeof useGetFormResponseQuery>;
export type GetFormResponseLazyQueryHookResult = ReturnType<typeof useGetFormResponseLazyQuery>;
export type GetFormResponseQueryResult = Apollo.QueryResult<GetFormResponseQuery, GetFormResponseQueryVariables>;
export const GetCreateObjectFormResponseDocument = gql`
    query GetCreateObjectFormResponse($service: Services!, $formId: String!, $payload: JSON!) {
  getCreateObjectFormResponse(
    service: $service
    formId: $formId
    payload: $payload
  )
}
    `;

/**
 * __useGetCreateObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateObjectFormResponseQuery({
 *   variables: {
 *      service: // value for 'service'
 *      formId: // value for 'formId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCreateObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>(GetCreateObjectFormResponseDocument, options);
      }
export function useGetCreateObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>(GetCreateObjectFormResponseDocument, options);
        }
export type GetCreateObjectFormResponseQueryHookResult = ReturnType<typeof useGetCreateObjectFormResponseQuery>;
export type GetCreateObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateObjectFormResponseLazyQuery>;
export type GetCreateObjectFormResponseQueryResult = Apollo.QueryResult<GetCreateObjectFormResponseQuery, GetCreateObjectFormResponseQueryVariables>;
export const GetEditObjectFormResponseDocument = gql`
    query GetEditObjectFormResponse($service: Services!, $formId: String!, $objectId: String!, $metadata: JSON) {
  getEditObjectFormResponse(
    service: $service
    formId: $formId
    objectId: $objectId
    metadata: $metadata
  )
}
    `;

/**
 * __useGetEditObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditObjectFormResponseQuery({
 *   variables: {
 *      service: // value for 'service'
 *      formId: // value for 'formId'
 *      objectId: // value for 'objectId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useGetEditObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>(GetEditObjectFormResponseDocument, options);
      }
export function useGetEditObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>(GetEditObjectFormResponseDocument, options);
        }
export type GetEditObjectFormResponseQueryHookResult = ReturnType<typeof useGetEditObjectFormResponseQuery>;
export type GetEditObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditObjectFormResponseLazyQuery>;
export type GetEditObjectFormResponseQueryResult = Apollo.QueryResult<GetEditObjectFormResponseQuery, GetEditObjectFormResponseQueryVariables>;
export const GetShareTokenDocument = gql`
    query GetShareToken($service: Services!, $objectId: String!) {
  getShareToken(service: $service, objectId: $objectId)
}
    `;

/**
 * __useGetShareTokenQuery__
 *
 * To run a query within a React component, call `useGetShareTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareTokenQuery({
 *   variables: {
 *      service: // value for 'service'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetShareTokenQuery(baseOptions: Apollo.QueryHookOptions<GetShareTokenQuery, GetShareTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareTokenQuery, GetShareTokenQueryVariables>(GetShareTokenDocument, options);
      }
export function useGetShareTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareTokenQuery, GetShareTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareTokenQuery, GetShareTokenQueryVariables>(GetShareTokenDocument, options);
        }
export type GetShareTokenQueryHookResult = ReturnType<typeof useGetShareTokenQuery>;
export type GetShareTokenLazyQueryHookResult = ReturnType<typeof useGetShareTokenLazyQuery>;
export type GetShareTokenQueryResult = Apollo.QueryResult<GetShareTokenQuery, GetShareTokenQueryVariables>;
export const GetMany2XOptionsDocument = gql`
    query GetMany2XOptions($serviceName: Services!, $domain: JSON!, $searchTerm: String!, $currentValue: [String]) {
  getMany2XOptions(
    serviceName: $serviceName
    domain: $domain
    searchTerm: $searchTerm
    currentValue: $currentValue
  ) {
    label
    value
  }
}
    `;

/**
 * __useGetMany2XOptionsQuery__
 *
 * To run a query within a React component, call `useGetMany2XOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMany2XOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMany2XOptionsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      domain: // value for 'domain'
 *      searchTerm: // value for 'searchTerm'
 *      currentValue: // value for 'currentValue'
 *   },
 * });
 */
export function useGetMany2XOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>(GetMany2XOptionsDocument, options);
      }
export function useGetMany2XOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>(GetMany2XOptionsDocument, options);
        }
export type GetMany2XOptionsQueryHookResult = ReturnType<typeof useGetMany2XOptionsQuery>;
export type GetMany2XOptionsLazyQueryHookResult = ReturnType<typeof useGetMany2XOptionsLazyQuery>;
export type GetMany2XOptionsQueryResult = Apollo.QueryResult<GetMany2XOptionsQuery, GetMany2XOptionsQueryVariables>;
export const GetCreateInspectionOnFormResponseDocument = gql`
    query GetCreateInspectionOnFormResponse($documentId: String!) {
  getCreateInspectionOnFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateInspectionOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateInspectionOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateInspectionOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateInspectionOnFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateInspectionOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>(GetCreateInspectionOnFormResponseDocument, options);
      }
export function useGetCreateInspectionOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>(GetCreateInspectionOnFormResponseDocument, options);
        }
export type GetCreateInspectionOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateInspectionOnFormResponseQuery>;
export type GetCreateInspectionOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateInspectionOnFormResponseLazyQuery>;
export type GetCreateInspectionOnFormResponseQueryResult = Apollo.QueryResult<GetCreateInspectionOnFormResponseQuery, GetCreateInspectionOnFormResponseQueryVariables>;
export const GetEditInspectionOnFormResponseDocument = gql`
    query GetEditInspectionOnFormResponse($objectId: String!, $documentId: String!) {
  getEditInspectionOnFormResponse(objectId: $objectId, documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditInspectionOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditInspectionOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditInspectionOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditInspectionOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditInspectionOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>(GetEditInspectionOnFormResponseDocument, options);
      }
export function useGetEditInspectionOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>(GetEditInspectionOnFormResponseDocument, options);
        }
export type GetEditInspectionOnFormResponseQueryHookResult = ReturnType<typeof useGetEditInspectionOnFormResponseQuery>;
export type GetEditInspectionOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditInspectionOnFormResponseLazyQuery>;
export type GetEditInspectionOnFormResponseQueryResult = Apollo.QueryResult<GetEditInspectionOnFormResponseQuery, GetEditInspectionOnFormResponseQueryVariables>;
export const GetEditReportFileOnInspectionDocument = gql`
    query GetEditReportFileOnInspection($objectId: String!) {
  getEditReportFileOnInspection(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditReportFileOnInspectionQuery__
 *
 * To run a query within a React component, call `useGetEditReportFileOnInspectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditReportFileOnInspectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditReportFileOnInspectionQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditReportFileOnInspectionQuery(baseOptions: Apollo.QueryHookOptions<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>(GetEditReportFileOnInspectionDocument, options);
      }
export function useGetEditReportFileOnInspectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>(GetEditReportFileOnInspectionDocument, options);
        }
export type GetEditReportFileOnInspectionQueryHookResult = ReturnType<typeof useGetEditReportFileOnInspectionQuery>;
export type GetEditReportFileOnInspectionLazyQueryHookResult = ReturnType<typeof useGetEditReportFileOnInspectionLazyQuery>;
export type GetEditReportFileOnInspectionQueryResult = Apollo.QueryResult<GetEditReportFileOnInspectionQuery, GetEditReportFileOnInspectionQueryVariables>;
export const GetSwissIntegrationSettingsDocument = gql`
    query GetSwissIntegrationSettings {
  integrationSettings {
    _id
    culture {
      name
    }
    swiss {
      productCode
      systemCode
      soilTypeCode
      valRiscoNomeado
      valSaca
      plantDate
    }
  }
}
    `;

/**
 * __useGetSwissIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useGetSwissIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissIntegrationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSwissIntegrationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>(GetSwissIntegrationSettingsDocument, options);
      }
export function useGetSwissIntegrationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>(GetSwissIntegrationSettingsDocument, options);
        }
export type GetSwissIntegrationSettingsQueryHookResult = ReturnType<typeof useGetSwissIntegrationSettingsQuery>;
export type GetSwissIntegrationSettingsLazyQueryHookResult = ReturnType<typeof useGetSwissIntegrationSettingsLazyQuery>;
export type GetSwissIntegrationSettingsQueryResult = Apollo.QueryResult<GetSwissIntegrationSettingsQuery, GetSwissIntegrationSettingsQueryVariables>;
export const GetSwissStateIntegrationSettingsDocument = gql`
    query GetSwissStateIntegrationSettings($settingId: String!) {
  integrationSetting(settingId: $settingId) {
    _id
    swiss {
      stateSettings {
        states
        valCusteio
      }
    }
  }
}
    `;

/**
 * __useGetSwissStateIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useGetSwissStateIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwissStateIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwissStateIntegrationSettingsQuery({
 *   variables: {
 *      settingId: // value for 'settingId'
 *   },
 * });
 */
export function useGetSwissStateIntegrationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>(GetSwissStateIntegrationSettingsDocument, options);
      }
export function useGetSwissStateIntegrationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>(GetSwissStateIntegrationSettingsDocument, options);
        }
export type GetSwissStateIntegrationSettingsQueryHookResult = ReturnType<typeof useGetSwissStateIntegrationSettingsQuery>;
export type GetSwissStateIntegrationSettingsLazyQueryHookResult = ReturnType<typeof useGetSwissStateIntegrationSettingsLazyQuery>;
export type GetSwissStateIntegrationSettingsQueryResult = Apollo.QueryResult<GetSwissStateIntegrationSettingsQuery, GetSwissStateIntegrationSettingsQueryVariables>;
export const GetCreateIntegrationSettingsFormResponseDocument = gql`
    query GetCreateIntegrationSettingsFormResponse($formId: String!) {
  getCreateIntegrationSettingsFormResponse(formId: $formId) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetCreateIntegrationSettingsFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateIntegrationSettingsFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateIntegrationSettingsFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateIntegrationSettingsFormResponseQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetCreateIntegrationSettingsFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>(GetCreateIntegrationSettingsFormResponseDocument, options);
      }
export function useGetCreateIntegrationSettingsFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>(GetCreateIntegrationSettingsFormResponseDocument, options);
        }
export type GetCreateIntegrationSettingsFormResponseQueryHookResult = ReturnType<typeof useGetCreateIntegrationSettingsFormResponseQuery>;
export type GetCreateIntegrationSettingsFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateIntegrationSettingsFormResponseLazyQuery>;
export type GetCreateIntegrationSettingsFormResponseQueryResult = Apollo.QueryResult<GetCreateIntegrationSettingsFormResponseQuery, GetCreateIntegrationSettingsFormResponseQueryVariables>;
export const GetEditIntegrationSettingsFormResponseDocument = gql`
    query GetEditIntegrationSettingsFormResponse($formId: String!, $objectId: String!, $listIndex: Float) {
  getEditIntegrationSettingsFormResponse(
    formId: $formId
    objectId: $objectId
    listIndex: $listIndex
  ) {
    formResponseId
    formId
  }
}
    `;

/**
 * __useGetEditIntegrationSettingsFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditIntegrationSettingsFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditIntegrationSettingsFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditIntegrationSettingsFormResponseQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      objectId: // value for 'objectId'
 *      listIndex: // value for 'listIndex'
 *   },
 * });
 */
export function useGetEditIntegrationSettingsFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>(GetEditIntegrationSettingsFormResponseDocument, options);
      }
export function useGetEditIntegrationSettingsFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>(GetEditIntegrationSettingsFormResponseDocument, options);
        }
export type GetEditIntegrationSettingsFormResponseQueryHookResult = ReturnType<typeof useGetEditIntegrationSettingsFormResponseQuery>;
export type GetEditIntegrationSettingsFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditIntegrationSettingsFormResponseLazyQuery>;
export type GetEditIntegrationSettingsFormResponseQueryResult = Apollo.QueryResult<GetEditIntegrationSettingsFormResponseQuery, GetEditIntegrationSettingsFormResponseQueryVariables>;
export const ListLeadsDocument = gql`
    query listLeads($filter: [[LeadFiltersInput]]!) {
  leads(filter: $filter) {
    _id
    area
    address {
      city
      state
      cep
    }
    type
    status
    name
    createdAt
    rating
    cultures {
      _id
      name
    }
  }
}
    `;

/**
 * __useListLeadsQuery__
 *
 * To run a query within a React component, call `useListLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListLeadsQuery(baseOptions: Apollo.QueryHookOptions<ListLeadsQuery, ListLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLeadsQuery, ListLeadsQueryVariables>(ListLeadsDocument, options);
      }
export function useListLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLeadsQuery, ListLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLeadsQuery, ListLeadsQueryVariables>(ListLeadsDocument, options);
        }
export type ListLeadsQueryHookResult = ReturnType<typeof useListLeadsQuery>;
export type ListLeadsLazyQueryHookResult = ReturnType<typeof useListLeadsLazyQuery>;
export type ListLeadsQueryResult = Apollo.QueryResult<ListLeadsQuery, ListLeadsQueryVariables>;
export const CountLeadsDocument = gql`
    query CountLeads($filter: [[LeadFiltersInput]]!) {
  countLeads(filter: $filter)
}
    `;

/**
 * __useCountLeadsQuery__
 *
 * To run a query within a React component, call `useCountLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountLeadsQuery(baseOptions: Apollo.QueryHookOptions<CountLeadsQuery, CountLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountLeadsQuery, CountLeadsQueryVariables>(CountLeadsDocument, options);
      }
export function useCountLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountLeadsQuery, CountLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountLeadsQuery, CountLeadsQueryVariables>(CountLeadsDocument, options);
        }
export type CountLeadsQueryHookResult = ReturnType<typeof useCountLeadsQuery>;
export type CountLeadsLazyQueryHookResult = ReturnType<typeof useCountLeadsLazyQuery>;
export type CountLeadsQueryResult = Apollo.QueryResult<CountLeadsQuery, CountLeadsQueryVariables>;
export const GetLeadDetailsDocument = gql`
    query GetLeadDetails($leadId: String!) {
  lead(leadId: $leadId) {
    _id
    type
    status
    name
    area
    address {
      city
      state
      street
    }
    comments
    createdAt
    email
    linkedin
    meetingIds
    phone
    rating
    commercialResponsibleId
    technicalResponsibleId
    cultures {
      _id
      name
    }
    meetings {
      _id
      status
      responsible {
        nome
      }
      date
      topic
      comment
      attachment
    }
  }
}
    `;

/**
 * __useGetLeadDetailsQuery__
 *
 * To run a query within a React component, call `useGetLeadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDetailsQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetLeadDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
      }
export function useGetLeadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
        }
export type GetLeadDetailsQueryHookResult = ReturnType<typeof useGetLeadDetailsQuery>;
export type GetLeadDetailsLazyQueryHookResult = ReturnType<typeof useGetLeadDetailsLazyQuery>;
export type GetLeadDetailsQueryResult = Apollo.QueryResult<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>;
export const GetEditLeadOnFormResponseDocument = gql`
    query GetEditLeadOnFormResponse($objectId: String!) {
  getEditLeadOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditLeadOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditLeadOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditLeadOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditLeadOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditLeadOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>(GetEditLeadOnFormResponseDocument, options);
      }
export function useGetEditLeadOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>(GetEditLeadOnFormResponseDocument, options);
        }
export type GetEditLeadOnFormResponseQueryHookResult = ReturnType<typeof useGetEditLeadOnFormResponseQuery>;
export type GetEditLeadOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditLeadOnFormResponseLazyQuery>;
export type GetEditLeadOnFormResponseQueryResult = Apollo.QueryResult<GetEditLeadOnFormResponseQuery, GetEditLeadOnFormResponseQueryVariables>;
export const GetCreateMeetingOnObjectFormResponseDocument = gql`
    query GetCreateMeetingOnObjectFormResponse($parentId: String!, $serviceName: Services!) {
  getCreateMeetingOnObjectFormResponse(
    parentId: $parentId
    serviceName: $serviceName
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateMeetingOnObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateMeetingOnObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateMeetingOnObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateMeetingOnObjectFormResponseQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useGetCreateMeetingOnObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>(GetCreateMeetingOnObjectFormResponseDocument, options);
      }
export function useGetCreateMeetingOnObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>(GetCreateMeetingOnObjectFormResponseDocument, options);
        }
export type GetCreateMeetingOnObjectFormResponseQueryHookResult = ReturnType<typeof useGetCreateMeetingOnObjectFormResponseQuery>;
export type GetCreateMeetingOnObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateMeetingOnObjectFormResponseLazyQuery>;
export type GetCreateMeetingOnObjectFormResponseQueryResult = Apollo.QueryResult<GetCreateMeetingOnObjectFormResponseQuery, GetCreateMeetingOnObjectFormResponseQueryVariables>;
export const GetEditMeetingOnObjectFormResponseDocument = gql`
    query GetEditMeetingOnObjectFormResponse($objectId: String!) {
  getEditMeetingOnObjectFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditMeetingOnObjectFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditMeetingOnObjectFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditMeetingOnObjectFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditMeetingOnObjectFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditMeetingOnObjectFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>(GetEditMeetingOnObjectFormResponseDocument, options);
      }
export function useGetEditMeetingOnObjectFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>(GetEditMeetingOnObjectFormResponseDocument, options);
        }
export type GetEditMeetingOnObjectFormResponseQueryHookResult = ReturnType<typeof useGetEditMeetingOnObjectFormResponseQuery>;
export type GetEditMeetingOnObjectFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditMeetingOnObjectFormResponseLazyQuery>;
export type GetEditMeetingOnObjectFormResponseQueryResult = Apollo.QueryResult<GetEditMeetingOnObjectFormResponseQuery, GetEditMeetingOnObjectFormResponseQueryVariables>;
export const NotesDocument = gql`
    query Notes($docId: String!, $serviceName: Services!) {
  notes(docId: $docId, serviceName: $serviceName) {
    text
    createdAt
    serviceName
    authorId {
      nome
    }
  }
}
    `;

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useNotesQuery(baseOptions: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
      }
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>;
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>;
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($serviceName: Services!) {
  notifications(serviceName: $serviceName) {
    notificationDate
    dateNotifications {
      notificationGroup
      groupNotifications {
        objectId
        serviceName
        createdAt
        text
        originInfo
        author {
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const GetCreatePaymentOnDocumentFormResponseDocument = gql`
    query GetCreatePaymentOnDocumentFormResponse($documentId: String!) {
  getCreatePaymentOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreatePaymentOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreatePaymentOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatePaymentOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatePaymentOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreatePaymentOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>(GetCreatePaymentOnDocumentFormResponseDocument, options);
      }
export function useGetCreatePaymentOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>(GetCreatePaymentOnDocumentFormResponseDocument, options);
        }
export type GetCreatePaymentOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreatePaymentOnDocumentFormResponseQuery>;
export type GetCreatePaymentOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreatePaymentOnDocumentFormResponseLazyQuery>;
export type GetCreatePaymentOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreatePaymentOnDocumentFormResponseQuery, GetCreatePaymentOnDocumentFormResponseQueryVariables>;
export const GetEditPaymentOnDocumentFormResponseDocument = gql`
    query GetEditPaymentOnDocumentFormResponse($objectId: String!) {
  getEditPaymentOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPaymentOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPaymentOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPaymentOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPaymentOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPaymentOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>(GetEditPaymentOnDocumentFormResponseDocument, options);
      }
export function useGetEditPaymentOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>(GetEditPaymentOnDocumentFormResponseDocument, options);
        }
export type GetEditPaymentOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPaymentOnDocumentFormResponseQuery>;
export type GetEditPaymentOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPaymentOnDocumentFormResponseLazyQuery>;
export type GetEditPaymentOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPaymentOnDocumentFormResponseQuery, GetEditPaymentOnDocumentFormResponseQueryVariables>;
export const GetCreatePolicyOnDocumentFormResponseDocument = gql`
    query GetCreatePolicyOnDocumentFormResponse($documentId: String!) {
  getCreatePolicyOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreatePolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreatePolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatePolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatePolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreatePolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>(GetCreatePolicyOnDocumentFormResponseDocument, options);
      }
export function useGetCreatePolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>(GetCreatePolicyOnDocumentFormResponseDocument, options);
        }
export type GetCreatePolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreatePolicyOnDocumentFormResponseQuery>;
export type GetCreatePolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreatePolicyOnDocumentFormResponseLazyQuery>;
export type GetCreatePolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreatePolicyOnDocumentFormResponseQuery, GetCreatePolicyOnDocumentFormResponseQueryVariables>;
export const GetEditPolicyOnDocumentFormResponseDocument = gql`
    query GetEditPolicyOnDocumentFormResponse($objectId: String!) {
  getEditPolicyOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditPolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>(GetEditPolicyOnDocumentFormResponseDocument, options);
      }
export function useGetEditPolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>(GetEditPolicyOnDocumentFormResponseDocument, options);
        }
export type GetEditPolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPolicyOnDocumentFormResponseQuery>;
export type GetEditPolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPolicyOnDocumentFormResponseLazyQuery>;
export type GetEditPolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPolicyOnDocumentFormResponseQuery, GetEditPolicyOnDocumentFormResponseQueryVariables>;
export const GetEditBillsOnDocumentFormResponseDocument = gql`
    query GetEditBillsOnDocumentFormResponse($objectId: String!) {
  getEditBillsOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditBillsOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditBillsOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditBillsOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditBillsOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditBillsOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>(GetEditBillsOnDocumentFormResponseDocument, options);
      }
export function useGetEditBillsOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>(GetEditBillsOnDocumentFormResponseDocument, options);
        }
export type GetEditBillsOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditBillsOnDocumentFormResponseQuery>;
export type GetEditBillsOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditBillsOnDocumentFormResponseLazyQuery>;
export type GetEditBillsOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditBillsOnDocumentFormResponseQuery, GetEditBillsOnDocumentFormResponseQueryVariables>;
export const GetCancelPolicyOnDocumentFormResponseDocument = gql`
    query GetCancelPolicyOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getCancelPolicyOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCancelPolicyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCancelPolicyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancelPolicyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancelPolicyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCancelPolicyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>(GetCancelPolicyOnDocumentFormResponseDocument, options);
      }
export function useGetCancelPolicyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>(GetCancelPolicyOnDocumentFormResponseDocument, options);
        }
export type GetCancelPolicyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCancelPolicyOnDocumentFormResponseQuery>;
export type GetCancelPolicyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCancelPolicyOnDocumentFormResponseLazyQuery>;
export type GetCancelPolicyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCancelPolicyOnDocumentFormResponseQuery, GetCancelPolicyOnDocumentFormResponseQueryVariables>;
export const GetEditPropertyOnDocumentFormResponseDocument = gql`
    query GetEditPropertyOnDocumentFormResponse($objectId: String!, $documentId: String!) {
  getEditPropertyOnDocumentFormResponse(
    objectId: $objectId
    documentId: $documentId
  ) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditPropertyOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditPropertyOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPropertyOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPropertyOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetEditPropertyOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>(GetEditPropertyOnDocumentFormResponseDocument, options);
      }
export function useGetEditPropertyOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>(GetEditPropertyOnDocumentFormResponseDocument, options);
        }
export type GetEditPropertyOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditPropertyOnDocumentFormResponseQuery>;
export type GetEditPropertyOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditPropertyOnDocumentFormResponseLazyQuery>;
export type GetEditPropertyOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditPropertyOnDocumentFormResponseQuery, GetEditPropertyOnDocumentFormResponseQueryVariables>;
export const GetCreateProposalOnDocumentFormResponseDocument = gql`
    query GetCreateProposalOnDocumentFormResponse($documentId: String!) {
  getCreateProposalOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateProposalOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateProposalOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateProposalOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateProposalOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateProposalOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>(GetCreateProposalOnDocumentFormResponseDocument, options);
      }
export function useGetCreateProposalOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>(GetCreateProposalOnDocumentFormResponseDocument, options);
        }
export type GetCreateProposalOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateProposalOnDocumentFormResponseQuery>;
export type GetCreateProposalOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateProposalOnDocumentFormResponseLazyQuery>;
export type GetCreateProposalOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateProposalOnDocumentFormResponseQuery, GetCreateProposalOnDocumentFormResponseQueryVariables>;
export const GetCreateResultOnDocumentFormResponseDocument = gql`
    query GetCreateResultOnDocumentFormResponse($documentId: String!) {
  getCreateResultOnDocumentFormResponse(documentId: $documentId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateResultOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateResultOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateResultOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateResultOnDocumentFormResponseQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetCreateResultOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>(GetCreateResultOnDocumentFormResponseDocument, options);
      }
export function useGetCreateResultOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>(GetCreateResultOnDocumentFormResponseDocument, options);
        }
export type GetCreateResultOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetCreateResultOnDocumentFormResponseQuery>;
export type GetCreateResultOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateResultOnDocumentFormResponseLazyQuery>;
export type GetCreateResultOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetCreateResultOnDocumentFormResponseQuery, GetCreateResultOnDocumentFormResponseQueryVariables>;
export const GetEditProposalOnDocumentFormResponseDocument = gql`
    query GetEditProposalOnDocumentFormResponse($objectId: String!) {
  getEditProposalOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditProposalOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditProposalOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditProposalOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditProposalOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditProposalOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>(GetEditProposalOnDocumentFormResponseDocument, options);
      }
export function useGetEditProposalOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>(GetEditProposalOnDocumentFormResponseDocument, options);
        }
export type GetEditProposalOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditProposalOnDocumentFormResponseQuery>;
export type GetEditProposalOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditProposalOnDocumentFormResponseLazyQuery>;
export type GetEditProposalOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditProposalOnDocumentFormResponseQuery, GetEditProposalOnDocumentFormResponseQueryVariables>;
export const GetEditResultOnDocumentFormResponseDocument = gql`
    query GetEditResultOnDocumentFormResponse($objectId: String!) {
  getEditResultOnDocumentFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditResultOnDocumentFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditResultOnDocumentFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditResultOnDocumentFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditResultOnDocumentFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditResultOnDocumentFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>(GetEditResultOnDocumentFormResponseDocument, options);
      }
export function useGetEditResultOnDocumentFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>(GetEditResultOnDocumentFormResponseDocument, options);
        }
export type GetEditResultOnDocumentFormResponseQueryHookResult = ReturnType<typeof useGetEditResultOnDocumentFormResponseQuery>;
export type GetEditResultOnDocumentFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditResultOnDocumentFormResponseLazyQuery>;
export type GetEditResultOnDocumentFormResponseQueryResult = Apollo.QueryResult<GetEditResultOnDocumentFormResponseQuery, GetEditResultOnDocumentFormResponseQueryVariables>;
export const GetCreateSignedProposalOnFormResponseDocument = gql`
    query getCreateSignedProposalOnFormResponse($proposalResultId: String!) {
  getCreateSignedProposalOnFormResponse(proposalResultId: $proposalResultId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetCreateSignedProposalOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetCreateSignedProposalOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateSignedProposalOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateSignedProposalOnFormResponseQuery({
 *   variables: {
 *      proposalResultId: // value for 'proposalResultId'
 *   },
 * });
 */
export function useGetCreateSignedProposalOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>(GetCreateSignedProposalOnFormResponseDocument, options);
      }
export function useGetCreateSignedProposalOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>(GetCreateSignedProposalOnFormResponseDocument, options);
        }
export type GetCreateSignedProposalOnFormResponseQueryHookResult = ReturnType<typeof useGetCreateSignedProposalOnFormResponseQuery>;
export type GetCreateSignedProposalOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetCreateSignedProposalOnFormResponseLazyQuery>;
export type GetCreateSignedProposalOnFormResponseQueryResult = Apollo.QueryResult<GetCreateSignedProposalOnFormResponseQuery, GetCreateSignedProposalOnFormResponseQueryVariables>;
export const GetEditSignedProposalOnFormResponseDocument = gql`
    query GetEditSignedProposalOnFormResponse($objectId: String!) {
  getEditSignedProposalOnFormResponse(objectId: $objectId) {
    formId
    formResponseId
  }
}
    `;

/**
 * __useGetEditSignedProposalOnFormResponseQuery__
 *
 * To run a query within a React component, call `useGetEditSignedProposalOnFormResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditSignedProposalOnFormResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditSignedProposalOnFormResponseQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetEditSignedProposalOnFormResponseQuery(baseOptions: Apollo.QueryHookOptions<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>(GetEditSignedProposalOnFormResponseDocument, options);
      }
export function useGetEditSignedProposalOnFormResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>(GetEditSignedProposalOnFormResponseDocument, options);
        }
export type GetEditSignedProposalOnFormResponseQueryHookResult = ReturnType<typeof useGetEditSignedProposalOnFormResponseQuery>;
export type GetEditSignedProposalOnFormResponseLazyQueryHookResult = ReturnType<typeof useGetEditSignedProposalOnFormResponseLazyQuery>;
export type GetEditSignedProposalOnFormResponseQueryResult = Apollo.QueryResult<GetEditSignedProposalOnFormResponseQuery, GetEditSignedProposalOnFormResponseQueryVariables>;
export const ModelTasksDocument = gql`
    query ModelTasks($serviceName: Services!, $objectId: String) {
  modelTasks(serviceName: $serviceName, objectId: $objectId) {
    modelName
    message
    docId
    dateDue
    responsible {
      nome
    }
    originInfo
  }
}
    `;

/**
 * __useModelTasksQuery__
 *
 * To run a query within a React component, call `useModelTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTasksQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useModelTasksQuery(baseOptions: Apollo.QueryHookOptions<ModelTasksQuery, ModelTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelTasksQuery, ModelTasksQueryVariables>(ModelTasksDocument, options);
      }
export function useModelTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelTasksQuery, ModelTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelTasksQuery, ModelTasksQueryVariables>(ModelTasksDocument, options);
        }
export type ModelTasksQueryHookResult = ReturnType<typeof useModelTasksQuery>;
export type ModelTasksLazyQueryHookResult = ReturnType<typeof useModelTasksLazyQuery>;
export type ModelTasksQueryResult = Apollo.QueryResult<ModelTasksQuery, ModelTasksQueryVariables>;
export const GetTwilioWaMessagesDocument = gql`
    query GetTwilioWAMessages($contactId: String!) {
  getTwilioWAMessages(contactId: $contactId) {
    messages {
      content
      sentAt
      createdAt
      type
      conversationId
      templateName
      _id
      status
      medias {
        externalId
        fileName
      }
    }
    contact {
      name
      mobilePhone
    }
    documentIds
  }
}
    `;

/**
 * __useGetTwilioWaMessagesQuery__
 *
 * To run a query within a React component, call `useGetTwilioWaMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioWaMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioWaMessagesQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetTwilioWaMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>(GetTwilioWaMessagesDocument, options);
      }
export function useGetTwilioWaMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>(GetTwilioWaMessagesDocument, options);
        }
export type GetTwilioWaMessagesQueryHookResult = ReturnType<typeof useGetTwilioWaMessagesQuery>;
export type GetTwilioWaMessagesLazyQueryHookResult = ReturnType<typeof useGetTwilioWaMessagesLazyQuery>;
export type GetTwilioWaMessagesQueryResult = Apollo.QueryResult<GetTwilioWaMessagesQuery, GetTwilioWaMessagesQueryVariables>;
export const GetTwilioMediaUrlDocument = gql`
    query GetTwilioMediaUrl($mediaId: String!) {
  getTwilioMediaUrl(mediaId: $mediaId)
}
    `;

/**
 * __useGetTwilioMediaUrlQuery__
 *
 * To run a query within a React component, call `useGetTwilioMediaUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioMediaUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioMediaUrlQuery({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useGetTwilioMediaUrlQuery(baseOptions: Apollo.QueryHookOptions<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>(GetTwilioMediaUrlDocument, options);
      }
export function useGetTwilioMediaUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>(GetTwilioMediaUrlDocument, options);
        }
export type GetTwilioMediaUrlQueryHookResult = ReturnType<typeof useGetTwilioMediaUrlQuery>;
export type GetTwilioMediaUrlLazyQueryHookResult = ReturnType<typeof useGetTwilioMediaUrlLazyQuery>;
export type GetTwilioMediaUrlQueryResult = Apollo.QueryResult<GetTwilioMediaUrlQuery, GetTwilioMediaUrlQueryVariables>;
export const GetTwilioConversationsDocument = gql`
    query GetTwilioConversations {
  getTwilioConversations {
    lastMsg {
      content
      sentAt
      medias {
        externalId
        fileName
      }
    }
    contact {
      _id
      name
      mobilePhone
    }
    notSeenCount
  }
}
    `;

/**
 * __useGetTwilioConversationsQuery__
 *
 * To run a query within a React component, call `useGetTwilioConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwilioConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwilioConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTwilioConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>(GetTwilioConversationsDocument, options);
      }
export function useGetTwilioConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>(GetTwilioConversationsDocument, options);
        }
export type GetTwilioConversationsQueryHookResult = ReturnType<typeof useGetTwilioConversationsQuery>;
export type GetTwilioConversationsLazyQueryHookResult = ReturnType<typeof useGetTwilioConversationsLazyQuery>;
export type GetTwilioConversationsQueryResult = Apollo.QueryResult<GetTwilioConversationsQuery, GetTwilioConversationsQueryVariables>;
export const ListUsersDocument = gql`
    query listUsers($filter: [[PartnersFiltersInput]]!) {
  users(filter: $filter) {
    _id
    role
    status
    nome
    email
    city
    state
    disabled
    profession
    signedDate
    responsibleId
    createdAt
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const CountUsersDocument = gql`
    query CountUsers($filter: [[PartnersFiltersInput]]!) {
  countUsers(filter: $filter)
}
    `;

/**
 * __useCountUsersQuery__
 *
 * To run a query within a React component, call `useCountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountUsersQuery(baseOptions: Apollo.QueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
      }
export function useCountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
export type CountUsersQueryHookResult = ReturnType<typeof useCountUsersQuery>;
export type CountUsersLazyQueryHookResult = ReturnType<typeof useCountUsersLazyQuery>;
export type CountUsersQueryResult = Apollo.QueryResult<CountUsersQuery, CountUsersQueryVariables>;
export const GetUserDetailsDocument = gql`
    query GetUserDetails($userId: String!) {
  user(userId: $userId) {
    _id
    role
    status
    signedDate
    createdAt
    disabled
    username
    nome
    email
    disabled
    phone
    cpf
    rg
    civilState
    cep
    city
    state
    profession
    rating
    comments
    cultureIds
    finishedCourse
    responsible {
      _id
      nome
    }
    meetings {
      _id
      status
      responsibleId
      responsible {
        nome
      }
      date
      topic
      comment
      attachment
    }
    indicators {
      _id
      totalArea
      totalPremium
      totalCommission
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const GetUserIndicatorsDocument = gql`
    query GetUserIndicators($userId: String!) {
  user(userId: $userId) {
    indicators {
      _id
      totalArea
      totalPremium
      totalCommission
    }
  }
}
    `;

/**
 * __useGetUserIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetUserIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIndicatorsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>(GetUserIndicatorsDocument, options);
      }
export function useGetUserIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>(GetUserIndicatorsDocument, options);
        }
export type GetUserIndicatorsQueryHookResult = ReturnType<typeof useGetUserIndicatorsQuery>;
export type GetUserIndicatorsLazyQueryHookResult = ReturnType<typeof useGetUserIndicatorsLazyQuery>;
export type GetUserIndicatorsQueryResult = Apollo.QueryResult<GetUserIndicatorsQuery, GetUserIndicatorsQueryVariables>;
export const OnConversationUpdatedDocument = gql`
    subscription OnConversationUpdated {
  conversationUpdated {
    contactId
    newMsg
  }
}
    `;

/**
 * __useOnConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnConversationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnConversationUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnConversationUpdatedSubscription, OnConversationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnConversationUpdatedSubscription, OnConversationUpdatedSubscriptionVariables>(OnConversationUpdatedDocument, options);
      }
export type OnConversationUpdatedSubscriptionHookResult = ReturnType<typeof useOnConversationUpdatedSubscription>;
export type OnConversationUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnConversationUpdatedSubscription>;
export const OnMsgSeenUpdatedDocument = gql`
    subscription OnMsgSeenUpdated {
  msgSeenUpdated {
    userId
  }
}
    `;

/**
 * __useOnMsgSeenUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMsgSeenUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMsgSeenUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMsgSeenUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnMsgSeenUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnMsgSeenUpdatedSubscription, OnMsgSeenUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMsgSeenUpdatedSubscription, OnMsgSeenUpdatedSubscriptionVariables>(OnMsgSeenUpdatedDocument, options);
      }
export type OnMsgSeenUpdatedSubscriptionHookResult = ReturnType<typeof useOnMsgSeenUpdatedSubscription>;
export type OnMsgSeenUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnMsgSeenUpdatedSubscription>;